import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  Json: any;
  NaiveDateTime: any;
  UUID4: any;
};

export type Account = {
  __typename?: 'Account';
  appId?: Maybe<Scalars['UUID4']>;
  credits: Array<Credit>;
  id?: Maybe<Scalars['UUID4']>;
  invoicing?: Maybe<Invoicing>;
  name?: Maybe<Scalars['String']>;
  sapLink?: Maybe<SapLink>;
  submittedOrders?: Maybe<SubmittedOrderPayload>;
  tags?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
};


export type AccountSubmittedOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['UUID4'];
  isDefault?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  type: Scalars['String'];
  user: User;
  zip: Scalars['String'];
};

export type AddressConfig = {
  __typename?: 'AddressConfig';
  countriesAllowed: Array<CountriesAllowed>;
  note?: Maybe<Scalars['String']>;
  requireValidation: ValidationRequirement;
  statesConfig: Array<StatesConfig>;
};

export type AllowedState = {
  __typename?: 'AllowedState';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AnalyticsConfig = {
  __typename?: 'AnalyticsConfig';
  gtm?: Maybe<GtmConfig>;
  projectId?: Maybe<Scalars['String']>;
  writeKey?: Maybe<Scalars['String']>;
};

export type BasicBehaviour = {
  __typename?: 'BasicBehaviour';
  name: BehaviourEnum;
};

export type Bazaarvoice = {
  __typename?: 'Bazaarvoice';
  encryptedEmail?: Maybe<Scalars['String']>;
  encryptionKeyId?: Maybe<Scalars['String']>;
};

/** Behaviour which may or may not have attributes */
export type Behaviour = BasicBehaviour | TieredBehaviour;

export enum BehaviourEnum {
  /** Basic discount logic, discounts all matching items by configured amount. */
  Basic = 'BASIC',
  /** Tiered discount logic, discounts matching items according to a tier structure. */
  Tiered = 'TIERED'
}

export type BraintreeAddress = {
  __typename?: 'BraintreeAddress';
  company?: Maybe<Scalars['String']>;
  countryCodeAlpha2?: Maybe<Scalars['String']>;
  countryCodeAlpha3?: Maybe<Scalars['String']>;
  countryCodeNumeric?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  extendedAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type BrandConfig = {
  __typename?: 'BrandConfig';
  audience: Scalars['String'];
  companyId?: Maybe<Scalars['String']>;
  contactUrl?: Maybe<Scalars['String']>;
  copyright: Scalars['String'];
  customCss?: Maybe<Scalars['String']>;
  customizations: BrandConfigCustomizations;
  email?: Maybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  optInText: Scalars['String'];
  supportEmail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  trackingFonts?: Maybe<Array<Maybe<BrandConfigTrackingFonts>>>;
  yearsAgeGate?: Maybe<Scalars['Int']>;
};

export type BrandConfigCustomizations = {
  __typename?: 'BrandConfigCustomizations';
  contacts: Array<BrandConfigCustomizationsContact>;
  css: Array<BrandConfigCustomizationsCss>;
  fonts: Array<BrandConfigCustomizationsFont>;
  images: Array<BrandConfigCustomizationsImage>;
  links: Array<BrandConfigCustomizationsLink>;
};

export type BrandConfigCustomizationsContact = {
  __typename?: 'BrandConfigCustomizationsContact';
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsCss = {
  __typename?: 'BrandConfigCustomizationsCss';
  overrides: Array<BrandConfigCustomizationsCssOverride>;
  selector: Scalars['String'];
};

export type BrandConfigCustomizationsCssOverride = {
  __typename?: 'BrandConfigCustomizationsCssOverride';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type BrandConfigCustomizationsFont = {
  __typename?: 'BrandConfigCustomizationsFont';
  meta?: Maybe<Array<BrandConfigCustomizationsFontMeta>>;
  name: Scalars['String'];
  style?: Maybe<Scalars['String']>;
  urls: Array<BrandConfigCustomizationsFontSources>;
  weight?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsFontMeta = {
  __typename?: 'BrandConfigCustomizationsFontMeta';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type BrandConfigCustomizationsFontSources = {
  __typename?: 'BrandConfigCustomizationsFontSources';
  format?: Maybe<Scalars['String']>;
  local?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsImage = {
  __typename?: 'BrandConfigCustomizationsImage';
  alt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  src: Scalars['String'];
};

export type BrandConfigCustomizationsLink = {
  __typename?: 'BrandConfigCustomizationsLink';
  location: Scalars['String'];
  newTab: Scalars['Boolean'];
  position: Scalars['Int'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type BrandConfigTrackingFonts = {
  __typename?: 'BrandConfigTrackingFonts';
  font: Scalars['String'];
  isTrackingRequired: Scalars['Boolean'];
  resource: Scalars['String'];
};

export type BundleItem = {
  __typename?: 'BundleItem';
  imgUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CalculateOrderDiscountsInput = {
  orderId?: InputMaybe<Scalars['UUID4']>;
  price?: InputMaybe<PriceInput>;
};

export type CalculateOrderDiscountsPayload = {
  __typename?: 'CalculateOrderDiscountsPayload';
  order?: Maybe<Order>;
};

export type CalculateOrderPayload = {
  __typename?: 'CalculateOrderPayload';
  order?: Maybe<Order>;
};

export type CancelOrderSubscriptionInput = {
  cancelReason: Scalars['String'];
  /** ID of Order Subscription */
  id: Scalars['UUID4'];
};

export type Capabilities = {
  __typename?: 'Capabilities';
  signUp: CapabilitiesSignUp;
};

/**
 * The sign up capability informs consumers of the API if the Tenant
 * allows users to sign up via the Secure Portal.
 */
export type CapabilitiesSignUp = {
  __typename?: 'CapabilitiesSignUp';
  enabled: Scalars['Boolean'];
};

export type Cart = {
  __typename?: 'Cart';
  appId: Scalars['UUID4'];
  id: Scalars['UUID4'];
  isGift?: Maybe<Scalars['Boolean']>;
  items: Array<CartItem>;
  user?: Maybe<User>;
  vendorConfig: Tenant;
};

export type CartItem = {
  __typename?: 'CartItem';
  analyticsDetails?: Maybe<Scalars['Json']>;
  customizations?: Maybe<Scalars['Json']>;
  id: Scalars['UUID4'];
  item: Item;
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
};

export type CartItemInput = {
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  customizations?: InputMaybe<Scalars['Json']>;
  id?: InputMaybe<Scalars['UUID4']>;
  itemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: InputMaybe<Scalars['Int']>;
};

export type Category = {
  __typename?: 'Category';
  appId: Scalars['UUID4'];
  level1?: Maybe<Scalars['String']>;
  level2?: Maybe<Scalars['String']>;
  level3?: Maybe<Scalars['String']>;
};

export type ChangeUserPasswordInput = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

export type Checkout = {
  __typename?: 'Checkout';
  paymentOptions?: Maybe<TenantPaymentOptions>;
};

export type Component = {
  __typename?: 'Component';
  id: Scalars['UUID4'];
  items?: Maybe<Array<Item>>;
  name: Scalars['String'];
  requiredQty: Scalars['Int'];
};

export type ContactConfig = {
  __typename?: 'ContactConfig';
  shippingAddressConfig: AddressConfig;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  bazaarvoice?: Maybe<Bazaarvoice>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<EmbeddedAddress>;
  user?: Maybe<User>;
  userString?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type ContactInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<EmbeddedAddressInput>;
  username?: InputMaybe<Scalars['String']>;
};

export type CountriesAllowed = {
  __typename?: 'CountriesAllowed';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CreatePaymentMethodInput = {
  default?: InputMaybe<Scalars['Boolean']>;
  deviceData: Scalars['String'];
  nonce: Scalars['String'];
};

/** Response when an order is created during checkout */
export type CreatedOrder = {
  __typename?: 'CreatedOrder';
  appId?: Maybe<Scalars['UUID4']>;
  cart?: Maybe<Cart>;
  contactInfo?: Maybe<ContactInfo>;
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  isGift?: Maybe<Scalars['Boolean']>;
  location?: Maybe<LatLong>;
  orderSubscription?: Maybe<OrderSubscription>;
  paymentRequest?: Maybe<PaymentRequest>;
  price: Price;
  requestedDeliveryDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  submissionUid?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type Credit = {
  __typename?: 'Credit';
  activeFrom: Scalars['Date'];
  activeUntil?: Maybe<Scalars['Date']>;
  availableAmount: Scalars['Int'];
  frozen: Scalars['Boolean'];
  id: Scalars['UUID4'];
  notes?: Maybe<Scalars['String']>;
  pendingAmount: Scalars['Int'];
  settledAmount: Scalars['Int'];
  spentAmount: Scalars['Int'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type CreditCard = {
  __typename?: 'CreditCard';
  billingAddress?: Maybe<BraintreeAddress>;
  cardType: Scalars['String'];
  cardholderName?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  default: Scalars['Boolean'];
  expirationMonth: Scalars['String'];
  expirationYear: Scalars['String'];
  last4: Scalars['String'];
  token: Scalars['String'];
  uniqueNumberIdentifier: Scalars['String'];
};

export type DeleteCreditCardInput = {
  token: Scalars['String'];
};

export type DeletePaymentMethodInput = {
  token: Scalars['String'];
};

export type Discount = {
  __typename?: 'Discount';
  activeFrom: Scalars['DateTime'];
  activeUntil?: Maybe<Scalars['DateTime']>;
  amount?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['UUID4']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  isPercent?: Maybe<Scalars['Boolean']>;
  isPromoCodeRequired?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  promoCode?: Maybe<Scalars['String']>;
  type?: Maybe<DiscountType>;
  typeDependentValue?: Maybe<Scalars['String']>;
  usage?: Maybe<Scalars['Int']>;
};

export enum DiscountType {
  /** Currently unused */
  GiftCard = 'GIFT_CARD',
  /** The discount is specific to a single item */
  Item = 'ITEM',
  /** The discount is specific to the discount's itemSet */
  ItemSet = 'ITEM_SET',
  /** The discount is specific to an entire tenant */
  Tenant = 'TENANT',
  /** The discount is specific to a specific vendor */
  Vendor = 'VENDOR'
}

export type Discounts = {
  __typename?: 'Discounts';
  discounts?: Maybe<Array<Discount>>;
};

export type DiscountsInput = {
  activeFrom: Scalars['DateTime'];
  activeUntil?: InputMaybe<Scalars['DateTime']>;
  amount?: InputMaybe<Scalars['Int']>;
  appId?: InputMaybe<Scalars['UUID4']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  isPercent?: InputMaybe<Scalars['Boolean']>;
  isPromoCodeRequired?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  promoCode?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  typeDependentValue?: InputMaybe<Scalars['String']>;
  usage?: InputMaybe<Scalars['Int']>;
};

export type DynamicBundle = {
  __typename?: 'DynamicBundle';
  appId: Scalars['UUID4'];
  components?: Maybe<Array<Component>>;
  id: Scalars['UUID4'];
  name: Scalars['String'];
  tag: Scalars['String'];
};

export type EmailNewsletterSignupInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  source?: InputMaybe<SourceType>;
};

export type EmailSspInput = {
  businessAddress: Scalars['String'];
  businessName: Scalars['String'];
  businessType: Scalars['String'];
  city: Scalars['String'];
  emailField: Scalars['String'];
  existingCustomer: Scalars['Boolean'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  manageAndOrder: Scalars['String'];
  numberOfUsers: Scalars['String'];
  phoneNumber: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type EmailSspResponse = {
  __typename?: 'EmailSspResponse';
  status: Scalars['String'];
};

export type EmbeddedAddress = {
  __typename?: 'EmbeddedAddress';
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  validated?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type EmbeddedAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  validated?: InputMaybe<Scalars['Boolean']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type EmbeddedCategory = {
  __typename?: 'EmbeddedCategory';
  level1?: Maybe<Scalars['String']>;
  level2?: Maybe<Scalars['String']>;
  level3?: Maybe<Scalars['String']>;
};

export type EmbeddedDiscount = {
  __typename?: 'EmbeddedDiscount';
  amount?: Maybe<Scalars['Int']>;
  isPercent?: Maybe<Scalars['Boolean']>;
};

export type EmbeddedItem = {
  __typename?: 'EmbeddedItem';
  awaitingImportCorrection?: Maybe<Scalars['Boolean']>;
  brandName?: Maybe<Scalars['String']>;
  categories?: Maybe<EmbeddedCategory>;
  color?: Maybe<Scalars['String']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  containerType?: Maybe<Scalars['String']>;
  countryCity?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  designerBio?: Maybe<Scalars['String']>;
  dimensionUnits?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Scalars['String']>;
  fluidOzPerPack?: Maybe<Scalars['Decimal']>;
  height?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  imgUrl?: Maybe<Scalars['String']>;
  importId?: Maybe<Scalars['UUID4']>;
  inventoryQty?: Maybe<Scalars['Int']>;
  isApproved?: Maybe<Scalars['Boolean']>;
  isDairyFree?: Maybe<Scalars['Boolean']>;
  isFairTrade?: Maybe<Scalars['Boolean']>;
  isGlutenFree?: Maybe<Scalars['Boolean']>;
  isGmoFree?: Maybe<Scalars['Boolean']>;
  isKosher?: Maybe<Scalars['Boolean']>;
  isOrganic?: Maybe<Scalars['String']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  isVegan?: Maybe<Scalars['Boolean']>;
  isWheatFree?: Maybe<Scalars['Boolean']>;
  isYeastFree?: Maybe<Scalars['Boolean']>;
  isbn?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  meltRisk?: Maybe<Scalars['Boolean']>;
  minOrderQty?: Maybe<Scalars['Int']>;
  onMarketplace?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
  primaryCategoryPriority?: Maybe<Scalars['Int']>;
  productPacks?: Maybe<Scalars['Int']>;
  productsPerPack?: Maybe<Scalars['Int']>;
  returnsPolicy?: Maybe<Scalars['String']>;
  secondaryCategoryPriority?: Maybe<Scalars['Int']>;
  shippingInfo?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugHash?: Maybe<Scalars['String']>;
  subscriptionMetadata?: Maybe<EmbeddedItemSubscriptionMetadata>;
  tags?: Maybe<Scalars['String']>;
  taxCodeId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['UUID4']>;
  weightOz?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type EmbeddedItemSubscriptionMetadata = {
  __typename?: 'EmbeddedItemSubscriptionMetadata';
  discount?: Maybe<EmbeddedDiscount>;
  isSubscribable: Scalars['Boolean'];
  subscriptionPrice?: Maybe<Scalars['Int']>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type FieldMeasure = {
  __typename?: 'FieldMeasure';
  eqv?: Maybe<Scalars['Int']>;
  eunit?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type FindAddressInput = {
  container?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type FoundAddress = {
  __typename?: 'FoundAddress';
  description?: Maybe<Scalars['String']>;
  highlight?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FoundItems = {
  __typename?: 'FoundItems';
  items?: Maybe<Array<FoundAddress>>;
};

export type Fulfillment = {
  __typename?: 'Fulfillment';
  carrierName?: Maybe<Scalars['String']>;
  externalFulfillmentId?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  insertedAt?: Maybe<Scalars['DateTime']>;
  items: Array<FulfillmentItem>;
  orderId?: Maybe<Scalars['UUID4']>;
  status?: Maybe<Scalars['String']>;
  taxServiceUpdatedAt?: Maybe<Scalars['NaiveDateTime']>;
  tracking?: Maybe<TrackingNumber>;
  trackingNumber?: Maybe<Scalars['String']>;
  /** @deprecated Prefer the "tracking" field which returns single tracking number info. */
  trackingNumbers: Array<TrackingNumber>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warehouseCode?: Maybe<Scalars['String']>;
};

export type FulfillmentItem = {
  __typename?: 'FulfillmentItem';
  insertedAt: Scalars['DateTime'];
  item?: Maybe<Item>;
  quantity?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type GetNutrientDetailInput = {
  gtins: Array<InputMaybe<Scalars['String']>>;
};

export type GiftConfig = {
  __typename?: 'GiftConfig';
  giftEmailConfig?: Maybe<GiftEmailConfig>;
  giftingEnabled?: Maybe<Scalars['Boolean']>;
};

export type GiftEmailConfig = {
  __typename?: 'GiftEmailConfig';
  centralImageUrl?: Maybe<Scalars['String']>;
  footerCopy?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
};

export type GtmConfig = {
  __typename?: 'GtmConfig';
  auth?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['String']>;
};

export type InvoicedAddress = {
  __typename?: 'InvoicedAddress';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  id: Scalars['UUID4'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type Invoicing = {
  __typename?: 'Invoicing';
  addresses: Array<InvoicedAddress>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type IsGiftInput = {
  id: Scalars['UUID4'];
  isGift: Scalars['Boolean'];
};

export type Item = {
  __typename?: 'Item';
  appId: Scalars['UUID4'];
  brandName?: Maybe<Scalars['String']>;
  caloriesPerPack?: Maybe<Scalars['Decimal']>;
  categories?: Maybe<Array<Maybe<Category>>>;
  color?: Maybe<Scalars['String']>;
  compareAtPrice: Scalars['Int'];
  containerType?: Maybe<Scalars['String']>;
  countryCity?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  designerBio?: Maybe<Scalars['String']>;
  dimensionUnits?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Scalars['String']>;
  fluidOzPerPack?: Maybe<Scalars['Decimal']>;
  gtin: Scalars['String'];
  height?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  imgUrl?: Maybe<Scalars['String']>;
  imgVariantUrls?: Maybe<Array<Maybe<ProductImageVariant>>>;
  inventoryQty?: Maybe<Scalars['Int']>;
  isDairyFree?: Maybe<Scalars['Boolean']>;
  isFairTrade?: Maybe<Scalars['Boolean']>;
  isGlutenFree?: Maybe<Scalars['Boolean']>;
  isGmoFree?: Maybe<Scalars['Boolean']>;
  isKosher?: Maybe<Scalars['Boolean']>;
  isOrganic?: Maybe<Scalars['String']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  isPending: Scalars['Boolean'];
  isVegan?: Maybe<Scalars['Boolean']>;
  isWheatFree?: Maybe<Scalars['Boolean']>;
  isYeastFree?: Maybe<Scalars['Boolean']>;
  isbn?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  meltRisk?: Maybe<Scalars['Boolean']>;
  minOrderQty?: Maybe<Scalars['Int']>;
  nutritionData?: Maybe<NutritionData>;
  onMarketplace?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
  primaryCategoryPriority?: Maybe<Scalars['Int']>;
  productPacks?: Maybe<Scalars['Int']>;
  productsPerPack?: Maybe<Scalars['Int']>;
  recommendedItems: Array<Item>;
  returnsPolicy?: Maybe<Scalars['String']>;
  secondaryCategoryPriority?: Maybe<Scalars['Int']>;
  shippingInfo?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Please use `slug` going forward. */
  slugHash?: Maybe<Scalars['String']>;
  stories?: Maybe<Array<Maybe<Story>>>;
  subItems?: Maybe<Array<Maybe<BundleItem>>>;
  subscriptionMetadata?: Maybe<ItemSubscriptionMetadata>;
  sugarGramsPerPack?: Maybe<Scalars['Decimal']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  taxCodeId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** @deprecated This field is deprecated, use `Gtin` in place of `Upc` */
  upc?: Maybe<Scalars['String']>;
  variantOptions?: Maybe<Array<Maybe<ProductVariant>>>;
  vendorConfig: Tenant;
  weightOz?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type ItemSubscriptionMetadata = {
  __typename?: 'ItemSubscriptionMetadata';
  discount?: Maybe<Discount>;
  id: Scalars['UUID4'];
  isSubscribable: Scalars['Boolean'];
  subscriptionPrice: Scalars['Int'];
};

export type ItemsInput = {
  basePrice?: InputMaybe<Scalars['Int']>;
  compareAtPrice?: InputMaybe<Scalars['Int']>;
  discountAmount?: InputMaybe<Scalars['Int']>;
  discountId?: InputMaybe<Scalars['UUID4']>;
  itemId?: InputMaybe<Scalars['UUID4']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shippingAmount?: InputMaybe<Scalars['Int']>;
  taxAmount?: InputMaybe<Scalars['Int']>;
};

export type ItemsPayload = {
  __typename?: 'ItemsPayload';
  items: Array<Item>;
  pagination: PaginationData;
};

export type LatLong = {
  __typename?: 'LatLong';
  lat: Scalars['Float'];
  long: Scalars['Float'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginUserInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Module = {
  __typename?: 'Module';
  body?: Maybe<Scalars['String']>;
  coverPhotoUrl?: Maybe<Scalars['String']>;
  cta1?: Maybe<Scalars['String']>;
  cta2?: Maybe<Scalars['String']>;
  cta3?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  isApproved?: Maybe<Scalars['Boolean']>;
  itemOrdering: Array<ModuleItem>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedTime?: Maybe<Scalars['String']>;
  story?: Maybe<Story>;
  storySlug: Scalars['String'];
  thumbnailItems: Array<ModuleThumbnailItem>;
  title1?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
  title3?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  urlOverride?: Maybe<Scalars['String']>;
};

export type ModuleItem = {
  __typename?: 'ModuleItem';
  item?: Maybe<Item>;
  module?: Maybe<Module>;
  order?: Maybe<Scalars['Int']>;
};

export type ModuleThumbnailItem = {
  __typename?: 'ModuleThumbnailItem';
  id?: Maybe<Scalars['String']>;
  imgUrl?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type NutrientDetail = {
  __typename?: 'NutrientDetail';
  brandName?: Maybe<Scalars['String']>;
  calciumDailyValuePercentage?: Maybe<Scalars['Float']>;
  calories?: Maybe<UnitAmount>;
  caloriesPerPack?: Maybe<Scalars['Float']>;
  carbohydrates?: Maybe<UnitAmount>;
  description?: Maybe<Scalars['String']>;
  fat?: Maybe<UnitAmount>;
  fluidOzPerPack?: Maybe<Scalars['Float']>;
  gtin?: Maybe<Scalars['String']>;
  imgUrl?: Maybe<Scalars['String']>;
  isDairyFree?: Maybe<Scalars['Boolean']>;
  isFairTrade?: Maybe<Scalars['Boolean']>;
  isGlutenFree?: Maybe<Scalars['Boolean']>;
  isGmoFree?: Maybe<Scalars['Boolean']>;
  isKosher?: Maybe<Scalars['Boolean']>;
  isOrganic?: Maybe<Scalars['String']>;
  isVegan?: Maybe<Scalars['Boolean']>;
  isWheatFree?: Maybe<Scalars['Boolean']>;
  isYeastFree?: Maybe<Scalars['Boolean']>;
  potassium?: Maybe<UnitAmount>;
  productName?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  protein?: Maybe<UnitAmount>;
  servingSize?: Maybe<UnitAmount>;
  sodium?: Maybe<UnitAmount>;
  sugarGramsPerPack?: Maybe<Scalars['Float']>;
  vitaminB6DailyValuePercentage?: Maybe<Scalars['Float']>;
};

export type NutrientDetailInput = {
  gtin: Scalars['String'];
};

export type NutritionData = {
  __typename?: 'NutritionData';
  code?: Maybe<Scalars['String']>;
  ingredientsTextEn?: Maybe<Scalars['String']>;
  nutrients?: Maybe<Array<Maybe<NutritionField>>>;
};

export type NutritionField = {
  __typename?: 'NutritionField';
  derivation?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  measures?: Maybe<Array<Maybe<FieldMeasure>>>;
  name?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  appId?: Maybe<Scalars['UUID4']>;
  cart?: Maybe<Cart>;
  contactInfo: ContactInfo;
  /**
   * @deprecated The concept of internal/external order ids is
   * being removed and this will be replaced by a
   * single field.
   *
   */
  externalOrderId?: Maybe<Scalars['String']>;
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  /**
   * @deprecated The concept of internal/external order ids is
   * being removed and this will be replaced by a
   * single field.
   *
   */
  internalOrderId: Scalars['Int'];
  isGift?: Maybe<Scalars['Boolean']>;
  location?: Maybe<LatLong>;
  paymentRequest?: Maybe<PaymentRequest>;
  price: Price;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type OrderInput = {
  gifteeEmail?: InputMaybe<Scalars['String']>;
  gifteeMessage?: InputMaybe<Scalars['String']>;
  giftorName?: InputMaybe<Scalars['String']>;
  isGift?: InputMaybe<Scalars['Boolean']>;
};

export type OrderSubscription = {
  __typename?: 'OrderSubscription';
  address: Address;
  /** @deprecated Please use status/status_reason */
  cancelReason?: Maybe<Scalars['String']>;
  /** @deprecated Please use status_updated_at */
  canceledAt?: Maybe<Scalars['Date']>;
  id: Scalars['UUID4'];
  initialOrderDate?: Maybe<Scalars['DateTime']>;
  insertedAt: Scalars['DateTime'];
  intervalInDays: Scalars['Int'];
  lastOrderAttempt?: Maybe<Scalars['DateTime']>;
  /** @deprecated Please use last_successful_order_date */
  lastSuccessfulOrder: Scalars['Date'];
  lastSuccessfulOrderDate: Scalars['Date'];
  /** @deprecated Please use next_order_creation_date */
  nextDeliveryDate: Scalars['Date'];
  nextOrderCreationDates: Array<Maybe<Scalars['Date']>>;
  orderSubscriptionItems: Array<OrderSubscriptionItem>;
  originatingOrder?: Maybe<SubmittedOrder>;
  paymentInfo: PaymentInfo;
  status: OrderSubscriptionStatusNames;
  statusReason?: Maybe<Scalars['String']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  vendorConfig: Tenant;
};

export type OrderSubscriptionItem = {
  __typename?: 'OrderSubscriptionItem';
  orderSubscription: OrderSubscription;
  priceItem: PriceItem;
};

export enum OrderSubscriptionRelationshipNames {
  /** Order that was a direct result of a subscription execution */
  Child = 'CHILD',
  /** Order with no relationship to any subscriptions */
  None = 'NONE',
  /** Order that resulted in subscriptions being made (priceItem had > 0 subscription_interval_in_days values) */
  Parent = 'PARENT'
}

export enum OrderSubscriptionStatusNames {
  /** Subscription is active and in valid state to fulfill */
  Active = 'ACTIVE',
  /** Subscription is canceled for reason stated in `status_reason` */
  Canceled = 'CANCELED',
  /** Subscription is paused for reason stated in `status_reason` */
  Paused = 'PAUSED'
}

export type OrderSubscriptionsPayload = {
  __typename?: 'OrderSubscriptionsPayload';
  orderSubscriptions: Array<OrderSubscription>;
};

export type PaginationData = {
  __typename?: 'PaginationData';
  count: Scalars['Int'];
  page: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginationInput = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};

export type PaymentClientTokenPayload = {
  __typename?: 'PaymentClientTokenPayload';
  token: Scalars['String'];
};

export type PaymentConfig = {
  __typename?: 'PaymentConfig';
  billingAddressConfig: AddressConfig;
  descriptor?: Maybe<Scalars['String']>;
  paymentTypes: Array<PaymentType>;
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  cardExpirationDate?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethodNames>;
  paymentType?: Maybe<Scalars['String']>;
  paypalEmail?: Maybe<Scalars['String']>;
  uniqueNumberIdentifier?: Maybe<Scalars['String']>;
};

/** object for holding a single default payment method */
export type PaymentMethod = CreditCard | PaypalAccount;

export enum PaymentMethodNames {
  /** Credit Card */
  CreditCard = 'CREDIT_CARD',
  /** Paypal Account */
  Paypal = 'PAYPAL'
}

/** object defined to hold the different payment methods */
export type PaymentMethods = {
  __typename?: 'PaymentMethods';
  creditCards?: Maybe<Array<CreditCard>>;
  default?: Maybe<PaymentMethod>;
  paypalAccounts?: Maybe<Array<PaypalAccount>>;
};

export type PaymentOptionsInput = {
  default?: InputMaybe<Scalars['Boolean']>;
  deviceData?: InputMaybe<Scalars['String']>;
  nonce?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  billingAddress?: Maybe<EmbeddedAddress>;
  isBillingEqualShipping?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<Scalars['String']>;
};

export type PaymentRequestInput = {
  billingAddress?: InputMaybe<EmbeddedAddressInput>;
  deviceData?: InputMaybe<Scalars['String']>;
  isBillingEqualShipping?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentToken?: InputMaybe<Scalars['String']>;
  saveCardForLater?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
};

export type PaymentType = {
  __typename?: 'PaymentType';
  brandImgUrl: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type PaypalAccount = {
  __typename?: 'PaypalAccount';
  billingAgreementId: Scalars['String'];
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  default: Scalars['Boolean'];
  email: Scalars['String'];
  imageUrl: Scalars['String'];
  isChannelInitated?: Maybe<Scalars['Boolean']>;
  payerInfo?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  token: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type Price = {
  __typename?: 'Price';
  discount?: Maybe<Scalars['Int']>;
  discounts: Array<Discount>;
  id?: Maybe<Scalars['UUID4']>;
  items: Array<PriceItem>;
  priceDiscounts: Array<PriceDiscount>;
  shipping?: Maybe<Scalars['Int']>;
  subtotal?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['Int']>;
  taxItems: Array<TaxItem>;
  total?: Maybe<Scalars['Int']>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PriceDiscount = {
  __typename?: 'PriceDiscount';
  discount?: Maybe<Discount>;
  price?: Maybe<Price>;
};

export type PriceInput = {
  discount?: InputMaybe<Scalars['Int']>;
  discounts?: InputMaybe<Array<InputMaybe<DiscountsInput>>>;
  items?: InputMaybe<Array<InputMaybe<ItemsInput>>>;
  shipping?: InputMaybe<Scalars['Int']>;
  subtotal?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

export type PriceItem = {
  __typename?: 'PriceItem';
  basePrice?: Maybe<Scalars['Int']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  /** Item in it's current state (may differ from embedded item) */
  currentItem?: Maybe<Item>;
  customizations?: Maybe<Scalars['Json']>;
  discountAmount?: Maybe<Scalars['Int']>;
  id: Scalars['UUID4'];
  /** Item as it was when purchased */
  item?: Maybe<EmbeddedItem>;
  itemId?: Maybe<Scalars['UUID4']>;
  price?: Maybe<Price>;
  quantity?: Maybe<Scalars['Int']>;
  /** @deprecated This field should not be used nor relied upon */
  shippingAmount?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  taxAmount?: Maybe<Scalars['Int']>;
  taxItems: Array<TaxItem>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
};

export type ProductImageVariant = {
  __typename?: 'ProductImageVariant';
  item?: Maybe<Item>;
  pos?: Maybe<Scalars['Int']>;
  src?: Maybe<Scalars['String']>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  item?: Maybe<Item>;
  variant?: Maybe<Item>;
  variantOptions?: Maybe<Array<Maybe<ProductVariantOption>>>;
};

export type ProductVariantOption = {
  __typename?: 'ProductVariantOption';
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  productVariant?: Maybe<ProductVariant>;
  value?: Maybe<Scalars['String']>;
};

/**
 * Inputs for requesting Password Reset for a User.
 *
 * The `state` field is used to pass information back to the browser when
 * as User clicks on the password reset link in their email. The state is
 * included as a query string appended to the URL. The value of `state` can
 * be any string, as long as it is URL safe.
 *
 * The API does not inspect or manipulate the `state`, it is simply passed
 * to the password reset link.
 */
export type RequestPasswordResetForUserInput = {
  email: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};

export type RequestPasswordResetForUserPayload = {
  __typename?: 'RequestPasswordResetForUserPayload';
  email: Scalars['String'];
};

export type ResetUserPasswordInput = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  token: Scalars['String'];
};

export type RestrictedItemsByZipCodePayload = {
  __typename?: 'RestrictedItemsByZipCodePayload';
  restrictedItems: Array<Item>;
};

export type RetrievedAddress = {
  __typename?: 'RetrievedAddress';
  adminAreaCode?: Maybe<Scalars['String']>;
  adminAreaName?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  buildingName?: Maybe<Scalars['String']>;
  buildingNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  dataLevel?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  domesticId?: Maybe<Scalars['String']>;
  field1?: Maybe<Scalars['String']>;
  field2?: Maybe<Scalars['String']>;
  field3?: Maybe<Scalars['String']>;
  field4?: Maybe<Scalars['String']>;
  field5?: Maybe<Scalars['String']>;
  field6?: Maybe<Scalars['String']>;
  field7?: Maybe<Scalars['String']>;
  field8?: Maybe<Scalars['String']>;
  field9?: Maybe<Scalars['String']>;
  field10?: Maybe<Scalars['String']>;
  field11?: Maybe<Scalars['String']>;
  field12?: Maybe<Scalars['String']>;
  field13?: Maybe<Scalars['String']>;
  field14?: Maybe<Scalars['String']>;
  field15?: Maybe<Scalars['String']>;
  field16?: Maybe<Scalars['String']>;
  field17?: Maybe<Scalars['String']>;
  field18?: Maybe<Scalars['String']>;
  field19?: Maybe<Scalars['String']>;
  field20?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  languageAlternatives?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  line3?: Maybe<Scalars['String']>;
  line4?: Maybe<Scalars['String']>;
  line5?: Maybe<Scalars['String']>;
  neighbourhood?: Maybe<Scalars['String']>;
  poBoxNumber?: Maybe<Scalars['String']>;
  secondaryStreet?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  subBuilding?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type RetrievedItems = {
  __typename?: 'RetrievedItems';
  items?: Maybe<Array<RetrievedAddress>>;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /**
   * Adds an item to a cart. Will create a new cart
   * if no `id` is included and cart is not already
   * associated with the requesting user. If a cart
   * already exists for the user or session we will
   * grab that cart and add the requested item.
   *
   * Cookie for cart is `decovo-shoppingcart`.
   *
   * Example:
   *   ```
   *   mutation AddCartItem($input: CartItemInput!) {
   *     addCartItem(input: $input) {
   *       id
   *       items {
   *         id
   *         quantity
   *         customizations
   *       }
   *     }
   *   }
   *   ```
   *   Variables:
   *
   *   ```
   *   {
   *     input: {
   *       "item_id": "a2e22ba6-b113-268b-e14e-ad501cb19e18",
   *       "quantity": 1
   *     }
   *   }
   *   ```
   */
  addCartItem?: Maybe<Cart>;
  /**
   * associates an anonymous Cart (a Cart without a `user_id`) to the current
   * authenticated User.
   */
  associateCartToUser?: Maybe<Cart>;
  /** Returns the order with the discounts applied. (Does not update order in DB) */
  calculateOrderDiscounts?: Maybe<CalculateOrderDiscountsPayload>;
  calculateOrderTaxes?: Maybe<CalculateOrderPayload>;
  /** @deprecated Please use update_order_subscription_status and set status to CANCELED and include a status_reason */
  cancelOrderSubscription?: Maybe<OrderSubscription>;
  changeUserPassword?: Maybe<User>;
  /**
   * Creates an order.
   *
   * Mutation
   * ```
   * mutation CreateOrder($cartId: String!, $input: OrderInput) {
   *   createOrder(cartId: $cartId, input: $input) {
   *     app_id
   *     cart{
   *         id
   *     }
   *     id
   *     status
   *     location {
   *       lat
   *       long
   *     }
   *     user {
   *       id
   *       first_name
   *       last_name
   *     }
   *     contact_info {
   *         email
   *         shipping_address{
   *             line1
   *         }
   *     }
   *     payment_request{
   *         billing_address{
   *             line1
   *         }
   *     }
   *     price{
   *         total
   *     }
   *     requested_delivery_date
   *     submission_uid
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "cartId": "bcde7722-bf35-4a41-bc56-b200ec3155ae",
   *   "input": {}
   * }
   * ```
   */
  createOrder?: Maybe<CreatedOrder>;
  createPaymentClientToken: PaymentClientTokenPayload;
  createPaymentMethod: PaymentMethod;
  createUserAddress: Address;
  deleteCreditCard: Scalars['String'];
  deletePaymentMethod: Scalars['String'];
  deleteUserAddress: Address;
  emailNewsletterSignup?: Maybe<Scalars['String']>;
  /** @deprecated Please use`loginUser` going forward. */
  login?: Maybe<User>;
  loginUser?: Maybe<User>;
  logoutUser?: Maybe<User>;
  /**
   * Requests a Password Reset for a User with the email provided.
   *
   * Mutation
   * ```
   * mutation RequestPasswordResetForUser($input: RequestPasswordResetForUserInput!) {
   *   requestPasswordResetForUser(input: $input) {
   *     email
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "input": {
   *     "email": "user@example.com"
   *   }
   * }
   * ```
   */
  requestPasswordResetForUser?: Maybe<RequestPasswordResetForUserPayload>;
  /**
   * This Mutation has been deprecated, please use `requestPasswordResetForUser`
   * @deprecated This Mutation has been deprecated, please use `requestPasswordResetForUser`
   *
   */
  requestUserPasswordReset?: Maybe<UserPasswordResetRequestPayload>;
  resetUserPassword?: Maybe<User>;
  /**
   * Example:
   *   ```
   *   mutation SendSspEmail($input: EmailSspInput!) {
   *     sendSspEmail(input: $input) {
   *       status
   *     }
   *   }
   *
   *   ```
   *   Variables:
   *
   *   ```
   *   {
   *     "input":{
   *       "firstName":"First name",
   *       "lastName":"Last name",
   *       "email":"email@pepsico.com",
   *       "businessName":"Pepsico",
   *       "businessAddress":"Business address",
   *       "businessType":"Business Type",
   *       "numberOfUsers":10,
   *       "existingCustomer": true,
   *       "manageAndOrder": "Manage and order",
   *       "city": "Benito Juarez",
   *       "state": "CDMX",
   *       "zip": "03023",
   *       "phone_number": "5512259112"
   *     }
   *   }
   *   ```
   */
  sendSspEmail?: Maybe<EmailSspResponse>;
  /** @deprecated Please use `signupUser` going forward. */
  signup?: Maybe<User>;
  signupUser?: Maybe<User>;
  skipOrderSubscription?: Maybe<OrderSubscription>;
  /**
   * Submits an order, returning the created submittedOrder.
   *
   * Mutation
   * ```
   * mutation SubmitOrder($orderId: UUID4!, $input: SubmitOrderInput!) {
   *   submitOrder(orderId: $orderId, input: $input) {
   *     app_id
   *     cart_id
   *     giftee_email
   *     giftee_message
   *     giftor_name
   *     is_gift
   *     price {
   *       discount
   *     }
   *     user {
   *       email
   *       first_name
   *       last_name
   *     }
   *     status
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   input: {
   *     contactInfo: {
   *       email: "tyrell1971@hoppe.name",
   *       phone: "5555555555",
   *       shippingAddress: {
   *         city: "city",
   *         company: "companyName",
   *         countryCode: "country",
   *         firstName: "firstName",
   *         lastName: "lastName",
   *         line1: "streetAddress",
   *         line2: "addressDetails",
   *         state: "AL",
   *         zip: "zipCode"
   *       }
   *     },
   *     paymentRequest: {
   *       billingAddress: {
   *         city: "city",
   *         company: "companyName",
   *         countryCode: "US",
   *         firstName: "firstName",
   *         lastName: "lastName",
   *         line1: "streetAddress",
   *         line2: "addressDetails",
   *         state: "AL",
   *         zip: "zipCode"
   *       },
   *       isBillingEqual_shipping: false,
   *       paymentMethod: "CREDIT_CARD",
   *       paymentToken: "token"
   *     },
   *     price: {discounts: []},
   *     requestedDeliveryDate: ~D[2021-10-05]
   *   },
   *   orderId: "e1215198-69be-4eb3-8e95-8ad441ebfe0a"
   * }
   * ```
   */
  submitOrder?: Maybe<SubmittedOrder>;
  updateCartGift?: Maybe<Cart>;
  updateCartItem?: Maybe<Cart>;
  updateCreditCardDefault: CreditCard;
  /**
   * Updates an order.
   *
   * Mutation
   * ```
   * mutation UpdateOrder($orderId: UUID4!, $input: UpdateOrderInput!) {
   *   updateOrder(orderId: $orderId, input: $input) {
   *     id
   *     appId
   *     requestedDeliveryDate
   *     contactInfo {
   *       email
   *       phone
   *       shippingAddress {
   *         city
   *         zip
   *       }
   *     }
   *     paymentRequest {
   *       paymentMethod
   *       isBillingEqualShipping
   *       billingAddress {
   *         city
   *         zip
   *       }
   *     }
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "order_id": "3965354a-260c-4fdd-a0d5-75f6efee4207",
   *   "input": {}
   * }
   * ```
   */
  updateOrder?: Maybe<CreatedOrder>;
  updateOrderSubscription?: Maybe<OrderSubscription>;
  updateOrderSubscriptionAddress?: Maybe<OrderSubscription>;
  updateOrderSubscriptionPayment?: Maybe<OrderSubscription>;
  updateOrderSubscriptionStatus?: Maybe<OrderSubscription>;
  updatePaymentMethodDefault: PaymentMethod;
  updateUserAddress: Address;
  updateUserAddressIsDefault: Address;
  /**
   * mutation UserAddressVerification {
   *     userAddressVerification(
   *       input: {
   *         first_name: "",
   *         last_name: "",
   *         company: "",
   *         country_code: "",
   *         city: "",
   *         state: "",
   *         zip: "",
   *         line1: "",
   *         line2: ""
   *       }
   *     )
   *     {
   *       first_name,
   *       last_name,
   *       company,
   *       country_code,
   *       city,
   *       state,
   *       zip,
   *       line1,
   *       line2,
   *       success,
   *       errors{
   *         code,
   *         field,
   *         message,
   *         suggestion
   *       }
   *     }
   *   }
   */
  userAddressVerification?: Maybe<VerifyAddressPayload>;
  /**
   * mutation AddressVerification {
   *     verifyAddressForOrder(
   *       orderId: "",
   *       input: {
   *         first_name: "",
   *         last_name: "",
   *         company: "",
   *         country_code: "",
   *         city: "",
   *         state: "",
   *         zip: "",
   *         special_instructions: "",
   *         line1: "",
   *         line2: ""
   *       }
   *     )
   *     {
   *       first_name,
   *       last_name,
   *       company,
   *       country_code,
   *       city,
   *       state,
   *       zip,
   *       line1,
   *       line2,
   *       special_instructions,
   *       success,
   *       errors{
   *         code,
   *         field,
   *         message,
   *         suggestion
   *       }
   *     }
   *   }
   */
  verifyAddressForOrder?: Maybe<VerifyAddressPayload>;
};


export type RootMutationTypeAddCartItemArgs = {
  input: CartItemInput;
};


export type RootMutationTypeAssociateCartToUserArgs = {
  cartId: Scalars['UUID4'];
};


export type RootMutationTypeCalculateOrderDiscountsArgs = {
  input: CalculateOrderDiscountsInput;
};


export type RootMutationTypeCalculateOrderTaxesArgs = {
  cartId?: InputMaybe<Scalars['UUID4']>;
  contactInfo?: InputMaybe<ContactInfoInput>;
  invoiceAddressId?: InputMaybe<Scalars['UUID4']>;
  orderId?: InputMaybe<Scalars['UUID4']>;
  paymentRequest?: InputMaybe<PaymentRequestInput>;
  price?: InputMaybe<PriceInput>;
};


export type RootMutationTypeCancelOrderSubscriptionArgs = {
  input?: InputMaybe<CancelOrderSubscriptionInput>;
};


export type RootMutationTypeChangeUserPasswordArgs = {
  input: ChangeUserPasswordInput;
};


export type RootMutationTypeCreateOrderArgs = {
  cartId: Scalars['String'];
  input?: InputMaybe<OrderInput>;
};


export type RootMutationTypeCreatePaymentMethodArgs = {
  input: CreatePaymentMethodInput;
};


export type RootMutationTypeCreateUserAddressArgs = {
  input: UserAddressInput;
};


export type RootMutationTypeDeleteCreditCardArgs = {
  input: DeleteCreditCardInput;
};


export type RootMutationTypeDeletePaymentMethodArgs = {
  input: DeletePaymentMethodInput;
};


export type RootMutationTypeDeleteUserAddressArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeEmailNewsletterSignupArgs = {
  input: EmailNewsletterSignupInput;
};


export type RootMutationTypeLoginArgs = {
  input: LoginInput;
};


export type RootMutationTypeLoginUserArgs = {
  input: LoginUserInput;
};


export type RootMutationTypeRequestPasswordResetForUserArgs = {
  input: RequestPasswordResetForUserInput;
};


export type RootMutationTypeRequestUserPasswordResetArgs = {
  email: Scalars['String'];
};


export type RootMutationTypeResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


export type RootMutationTypeSendSspEmailArgs = {
  input: EmailSspInput;
};


export type RootMutationTypeSignupArgs = {
  input: SignupInput;
};


export type RootMutationTypeSignupUserArgs = {
  input: SignupUserInput;
};


export type RootMutationTypeSkipOrderSubscriptionArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeSubmitOrderArgs = {
  input?: InputMaybe<SubmitOrderInput>;
  orderId: Scalars['String'];
};


export type RootMutationTypeUpdateCartGiftArgs = {
  input: IsGiftInput;
};


export type RootMutationTypeUpdateCartItemArgs = {
  input: CartItemInput;
};


export type RootMutationTypeUpdateCreditCardDefaultArgs = {
  input: UpdateCreditCardDefaultInput;
};


export type RootMutationTypeUpdateOrderArgs = {
  input: UpdateOrderInput;
  orderId: Scalars['UUID4'];
};


export type RootMutationTypeUpdateOrderSubscriptionArgs = {
  input: UpdateOrderSubscriptionInput;
};


export type RootMutationTypeUpdateOrderSubscriptionAddressArgs = {
  input: UpdateOrderSubscriptionAddressInput;
};


export type RootMutationTypeUpdateOrderSubscriptionPaymentArgs = {
  input: UpdateOrderSubscriptionPaymentInput;
};


export type RootMutationTypeUpdateOrderSubscriptionStatusArgs = {
  input: UpdateOrderSubscriptionStatusInput;
};


export type RootMutationTypeUpdatePaymentMethodDefaultArgs = {
  input: UpdatePaymentMethodDefaultInput;
};


export type RootMutationTypeUpdateUserAddressArgs = {
  id: Scalars['UUID4'];
  input: UserAddressInput;
};


export type RootMutationTypeUpdateUserAddressIsDefaultArgs = {
  id: Scalars['UUID4'];
  input: UserAddressIsDefaultInput;
};


export type RootMutationTypeUserAddressVerificationArgs = {
  input: VerifyAddressInput;
};


export type RootMutationTypeVerifyAddressForOrderArgs = {
  input: VerifyAddressInput;
  orderId: Scalars['String'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /**
   * Gets the currently active account
   * Example:
   *   ```
   *   query {
   *     activeAccount {
   *       type
   *       credits {
   *         status
   *         type
   *         availableAmount
   *         spentAmount
   *         activeFrom
   *         activeUntil
   *       }
   *     }
   *   }
   *   ```
   */
  activeAccount?: Maybe<Account>;
  /** Retrieves a cart given an id */
  cart?: Maybe<Cart>;
  /** Retrieves a cart given a hashed email for Salesforce */
  cartRecovery?: Maybe<Cart>;
  /**
   * Gets the currently logged in user
   * Example:
   *   ```
   *   query {
   *     currentUser {
   *       email
   *       firstName
   *       lastName
   *       creditCards {
   *         cardholderName
   *         billingAddress{
   *           firstName
   *           lastName
   *         }
   *       }
   *       addresses{
   *         line1
   *         line2
   *       }
   *     }
   *   }
   *   ```
   */
  currentUser?: Maybe<User>;
  /**
   * Retrieve a Dynamic Bundle, its Components, and all Items associated.
   * Example:
   * ```
   * query DynamicBundle($id: UUID4!) {
   *   dynamicBundle(id: $id) {
   *     id
   *     name
   *     tag
   *     components {
   *       id
   *       name
   *       required_qty
   *       items {
   *         id
   *         gtin
   *         is_dairy_free
   *         is_gluten_free
   *       }
   *     }
   *   }
   * }
   *
   * {"id": "bundle_id"}
   * ```
   */
  dynamicBundle?: Maybe<DynamicBundle>;
  /**
   * Retrieve all Dynamic Bundles and their Components.
   * Example:
   * ```
   * query DynamicBundles {
   *   dynamicBundles {
   *     id
   *     name
   *     tag
   *     components {
   *       id
   *       name
   *       required_qty
   *     }
   *   }
   * }
   * ```
   */
  dynamicBundles?: Maybe<Array<Maybe<DynamicBundle>>>;
  /** Lookup all Feature Flags. If a `User` is logged in, the Feature Flags will reflect `User` specific Feature Flags. */
  featureFlags: Array<FeatureFlag>;
  /**
   * Get address suggestions for easy user input
   * Example
   * ```
   * query FindAddress($input: FindAddressInput!) {
   *   findAddress(input: $input) {
   *     items {
   *       id
   *       value
   *       description
   *       type
   *       highlight
   *     }
   *   }
   * }
   *
   * {"input": {"text": "3110 Pepsi road", "limit": "10"}}
   * ```
   */
  findAddress?: Maybe<FoundItems>;
  /**
   * Return a list of items, paginated
   * Example:
   *   ```
   *   query getItems {
   *     getItems(
   *       pagination: {
   *         page: 1
   *         limit: 10
   *       }) {
   *       items {
   *         id
   *       }
   *     }
   *   }
   *   ```
   * @deprecated Please use `items` going forward.
   */
  getItems?: Maybe<ItemsPayload>;
  /**
   * Returns an `Item` for the given `GTIN`.
   *
   * Example
   * ```
   * query ItemByGtin($gtin: String!) {
   *   itemByGtin(gtin: $gtin) {
   *     id
   *     description
   *     title
   *   }
   * }
   *
   * {"gtin": "000111222333444555}
   * ```
   */
  itemByGtin?: Maybe<Item>;
  /**
   * Return the item by its id
   * Example:
   *   ```
   *   query itemById($id: String!) {
   *     itemById(id: $id) {
   *       id
   *       description
   *     }
   *   }
   *  {"id": "id"}
   *   ```
   */
  itemById?: Maybe<Item>;
  /**
   * Return the item by its slug
   * Example:
   *   ```
   *   query itemBySlug($slug: String!) {
   *     itemBySlug(slug: $slug) {
   *       id
   *       description
   *     }
   *   }
   *  {"slug": "slug"}
   *   ```
   */
  itemBySlug?: Maybe<Item>;
  /**
   * Return a list of items, paginated
   * Example:
   *   ```
   *   query getItems {
   *     getItems(
   *       pagination: {
   *         page: 1
   *         limit: 10
   *       }) {
   *       items {
   *         id
   *       }
   *     }
   *   }
   *   ```
   */
  items?: Maybe<ItemsPayload>;
  /**
   * Return a list of items, paginated
   * Example:
   *   ```
   *   query getItems {
   *     getItems(
   *       pagination: {
   *         page: 1
   *         limit: 10
   *       }) {
   *       items {
   *         id
   *       }
   *     }
   *   }
   *   ```
   */
  itemsSearch?: Maybe<ItemsPayload>;
  modules: Array<Module>;
  nutrientDetail?: Maybe<NutrientDetail>;
  nutrientDetails?: Maybe<Array<Maybe<NutrientDetail>>>;
  /**
   * Return a single order filtered by id
   * Example:
   *   ```
   *   query OrderQueries {
   *     order(order_id: order_uuid) {
   *       id
   *     }
   *   }
   *   ```
   */
  order?: Maybe<Order>;
  /**
   * query getOrderSubscriptionForUser($id: UUID4!) {
   *   orderSubscription(id: $id) {
   *     id
   *     title
   *     intervalInDays
   *     orderSubscriptionItems {
   *       priceItem {
   *         basePrice
   *         id
   *       }
   *     }
   *   }
   * }
   */
  orderSubscription?: Maybe<OrderSubscription>;
  /**
   * query getAllOrderSubscriptionsForUser {
   *   orderSubscriptions {
   *     orderSubscriptions {
   *       id
   *       title
   *       intervalInDays
   *       orderSubscriptionItems {
   *         priceItem {
   *           basePrice
   *           id
   *         }
   *       }
   *     }
   *   }
   * }
   */
  orderSubscriptions?: Maybe<OrderSubscriptionsPayload>;
  /**
   * Returns a list of items forbidden from being sold in the given zip code.
   * If a list of upcs is given, it will check only those items, otherwise will check all items in the store.
   * Example:
   *   ```
   *   query RestrictedItemsByZipCode {
   *     restrictedItemsByZipCode(
   *       zip: "94545",
   *       upcs: ["2141212", "2142145432"]) {
   *       restrictedItems {
   *         id
   *       }
   *     }
   *   }
   *   ```
   */
  restrictedItemsByZipCode?: Maybe<RestrictedItemsByZipCodePayload>;
  /**
   * Retrieve an address with an id.
   *
   * Example
   * ```
   * query RetrieveAddress($id: String!) {
   *   retrieveAddress(id: $id) {
   *     items {
   *       id
   *       line1
   *       line2
   *       city
   *       state
   *       zip
   *       country
   *     }
   *   }
   * }
   *
   * {"id": "id_12345678"}
   * ```
   */
  retrieveAddress?: Maybe<RetrievedItems>;
  /**
   * Searchs and displays an application's list of
   * discounts which meet certain requirements.
   *
   * typeDependentValue can be one of the following values:
   * - vendor_id
   * - item_id
   * - app_id
   *
   * type can be one of the following values:
   * - BRAND
   * - PRODUCT
   * - VENDOR
   * - ITEM_SET
   *
   * itemSet is a list of item ids to match against if the campaign is an itemSet campaign.
   *
   * behaviour can be one of the following
   * - BASIC
   * - TIERED
   *
   * Query
   *
   *   ```
   *   query SearchDiscounts($input: SearchDiscountsInput!) {
   *     searchDiscounts(input: $input) {
   *       discounts{
   *         id
   *         activeFrom
   *         activeUntil
   *         amount
   *         appId
   *         isPercent
   *         isPromoCodeRequired
   *         limit
   *         promoCode
   *         type
   *         typeDependentValue
   *         usage
   *       }
   *     }
   *   }
   *   ```
   *
   *   Input Examples
   *
   *   Finding a basic item specific discount with a promo code
   *   ```
   *   {
   *     input: {
   *       "type": "ITEM",
   *       "typeDependentValue": "a2e22ba6-b113-268b-e14e-ad501cb19e18",
   *       "promoCode": "PROMOCODE",
   *       "behaviour": "BASIC"
   *     }
   *   }
   *   ```
   *   Finding a tiered discount that includes a specific item in its itemSet
   *   ```
   *   {
   *     input: {
   *       "type": "ITEM_SET",
   *       "behaviour": "TIERED",
   *       "itemSet": [""a2e22ba6-b113-268b-e14e-ad501cb19e18""]
   *     }
   *   }
   *   ```
   */
  searchDiscounts?: Maybe<Discounts>;
  /**
   * Returns a `Story` with the given `id`.
   *
   * Example:
   * ```
   * query StoryById($id: UUID4!) {
   *   story: storyById(id: $id) {
   *     app_id
   *     body
   *     cta1
   *     cta2
   *     cta3
   *     id
   *     insertedAt
   *     moduleType
   *     slug
   *     slugHash
   *     tags
   *     title1
   *     title2
   *     title3
   *     updatedAt
   *   }
   * }
   * ```
   */
  story?: Maybe<Story>;
  /**
   * Returns a `Story` with the given `id`.
   *
   * Example:
   * ```
   * query StoryById($id: UUID4!) {
   *   story: storyById(id: $id) {
   *     app_id
   *     body
   *     cta1
   *     cta2
   *     cta3
   *     id
   *     insertedAt
   *     moduleType
   *     slug
   *     slugHash
   *     tags
   *     title1
   *     title2
   *     title3
   *     updatedAt
   *   }
   * }
   * ```
   * @deprecated Use "story" query with ID parameter in favor of "storyById"
   */
  storyById?: Maybe<Story>;
  /**
   * Returns a `Story` with the given `slug`.
   *
   * Example:
   * ```
   * query StoryBySlug($slug: String!) {
   *   story: storyBySlug(slug: $slug) {
   *     app_id
   *     body
   *     cta1
   *     cta2
   *     cta3
   *     id
   *     insertedAt
   *     moduleType
   *     slug
   *     slugHash
   *     tags
   *     title1
   *     title2
   *     title3
   *     updatedAt
   *   }
   * }
   * ```
   * @deprecated Use "story" query with ID parameter in favor of "storyBySlug"
   */
  storyBySlug?: Maybe<Story>;
  /**
   * Return a single submitted order filtered by id
   * Example:
   *   ```
   *   query SubmittedOrderQueries {
   *     submitted_order(order_id: order_uuid) {
   *       id
   *     }
   *   }
   *   ```
   */
  submittedOrder?: Maybe<SubmittedOrder>;
  /**
   * Return a list of orders, paginated, for the current user
   * Example:
   *   ```
   *   query SubmittedOrderQueries {
   *     submitted_orders(
   *       pagination: {
   *         page: 1
   *         limit: 10
   *       }) {
   *       orders_count
   *       submitted_orders {
   *       id
   *       }
   *     }
   *   }
   *   ```
   */
  submittedOrders: SubmittedOrderPayload;
  /**
   * Return the `Tenant` associated with the domain of the site making the request
   * Example:
   *   ```
   *   query {
   *     tenant {
   *       appId
   *       domain
   *       fallbackUrl
   *     }
   *   }
   *   ```
   */
  tenant?: Maybe<Tenant>;
  /**
   * Returns a list of items forbidden from being sold in the given zip code.
   * If a list of upcs is given, it will check only those items, otherwise will check all items in the store.
   * Example:
   *   ```
   *   query validateZipcode {
   *     validateZipcode(
   *       zip: "94545",
   *       upcs: ["2141212", "2142145432"]) {
   *       restrictedItems {
   *         id
   *       }
   *     }
   *   }
   *   ```
   * @deprecated Please use `restrictedItemsByZipCode` going forward.
   */
  validateZipcode?: Maybe<ValidateZipcodePayload>;
  /**
   * Deprecated in favor or `tenant`.
   *
   * Return the VendorConfig associated with the domain of the site making the request
   * Example:
   *   ```
   *   query {
   *     vendorConfig {
   *       appId
   *       domain
   *       fallbackUrl
   *     }
   *   }
   *   ```
   * @deprecated This Query has been deprecated in favor of `tenant`.
   *
   *
   */
  vendorConfig?: Maybe<Tenant>;
};


export type RootQueryTypeCartArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeCartRecoveryArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeDynamicBundleArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeFindAddressArgs = {
  input: FindAddressInput;
};


export type RootQueryTypeGetItemsArgs = {
  brands?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isOutOfStock?: InputMaybe<Scalars['Boolean']>;
  onMarketplace?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  storyId?: InputMaybe<Scalars['String']>;
  upcs?: InputMaybe<Array<Scalars['String']>>;
};


export type RootQueryTypeItemByGtinArgs = {
  gtin: Scalars['String'];
};


export type RootQueryTypeItemByIdArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeItemBySlugArgs = {
  brands?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isOutOfStock?: InputMaybe<Scalars['Boolean']>;
  onMarketplace?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  storyId?: InputMaybe<Scalars['String']>;
  upcs?: InputMaybe<Array<Scalars['String']>>;
};


export type RootQueryTypeItemsArgs = {
  brands?: InputMaybe<Array<Scalars['String']>>;
  gtins?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isOutOfStock?: InputMaybe<Scalars['Boolean']>;
  onMarketplace?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  storyId?: InputMaybe<Scalars['String']>;
  upcs?: InputMaybe<Array<Scalars['String']>>;
};


export type RootQueryTypeItemsSearchArgs = {
  pagination?: InputMaybe<PaginationInput>;
  term?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeNutrientDetailArgs = {
  input: NutrientDetailInput;
};


export type RootQueryTypeNutrientDetailsArgs = {
  input?: InputMaybe<GetNutrientDetailInput>;
};


export type RootQueryTypeOrderArgs = {
  orderId: Scalars['UUID4'];
};


export type RootQueryTypeOrderSubscriptionArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeRestrictedItemsByZipCodeArgs = {
  upcs?: InputMaybe<Array<Scalars['String']>>;
  zip: Scalars['String'];
};


export type RootQueryTypeRetrieveAddressArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeSearchDiscountsArgs = {
  input: SearchDiscountsInput;
};


export type RootQueryTypeStoryArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeStoryByIdArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeStoryBySlugArgs = {
  slug: Scalars['String'];
};


export type RootQueryTypeSubmittedOrderArgs = {
  orderId: Scalars['UUID4'];
};


export type RootQueryTypeSubmittedOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeValidateZipcodeArgs = {
  upcs?: InputMaybe<Array<Scalars['String']>>;
  zip: Scalars['String'];
};

export type SapLink = {
  __typename?: 'SapLink';
  activeCustomerIds?: Maybe<Array<Scalars['String']>>;
  customerIds?: Maybe<Array<Scalars['String']>>;
  primaryCustomerId?: Maybe<Scalars['String']>;
  propertyId?: Maybe<Scalars['String']>;
};

export type SearchDiscountsInput = {
  behaviour?: InputMaybe<BehaviourEnum>;
  itemSet?: InputMaybe<Array<Scalars['String']>>;
  promoCode?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DiscountType>;
  typeDependentValue?: InputMaybe<Scalars['UUID4']>;
};

export type ShippingConfig = {
  __typename?: 'ShippingConfig';
  fixedFeeShipping?: Maybe<Scalars['Int']>;
  freeShippingThreshold?: Maybe<Scalars['Int']>;
  maxDeliveryWindowInDays?: Maybe<Scalars['Int']>;
};

export type ShoppingBagConfig = {
  __typename?: 'ShoppingBagConfig';
  availableSubscriptionIntervalsInDays: Array<Scalars['Int']>;
  maxAmountForSelect: Scalars['Int'];
  minimumPurchaseAmount: Scalars['Int'];
  minimumPurchaseQty: Scalars['Int'];
  orderSubscriptionsEnabled: Scalars['Boolean'];
  subscriptionIntervalsInDays: Array<Scalars['Int']>;
};

export type SignupInput = {
  activationCode?: InputMaybe<Scalars['String']>;
  activationCodeRequired?: InputMaybe<Scalars['Boolean']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

export type SignupUserInput = {
  activationCode?: InputMaybe<Scalars['String']>;
  activationCodeRequired?: InputMaybe<Scalars['Boolean']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

/** identifies the front end source of incoming data */
export enum SourceType {
  Default = 'DEFAULT',
  Footer = 'FOOTER'
}

export type StatesConfig = {
  __typename?: 'StatesConfig';
  countryId: Scalars['String'];
  statesAllowed: Array<AllowedState>;
};

export type Story = {
  __typename?: 'Story';
  appId?: Maybe<Scalars['ID']>;
  body?: Maybe<Scalars['String']>;
  cta1?: Maybe<Scalars['String']>;
  cta2?: Maybe<Scalars['String']>;
  cta3?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  insertedAt?: Maybe<Scalars['DateTime']>;
  items?: Maybe<Array<Maybe<Item>>>;
  module?: Maybe<Module>;
  moduleType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugHash?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title1?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
  title3?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubmitOrderInput = {
  contactInfo: ContactInfoInput;
  gifteeEmail?: InputMaybe<Scalars['String']>;
  gifteeMessage?: InputMaybe<Scalars['String']>;
  giftorName?: InputMaybe<Scalars['String']>;
  invoiceAddressId?: InputMaybe<Scalars['UUID4']>;
  isGift?: InputMaybe<Scalars['Boolean']>;
  paymentRequest: PaymentRequestInput;
  price: PriceInput;
  requestedDeliveryDate?: InputMaybe<Scalars['Date']>;
};

export type SubmittedOrder = {
  __typename?: 'SubmittedOrder';
  appId?: Maybe<Scalars['UUID4']>;
  cart?: Maybe<Cart>;
  cartId?: Maybe<Scalars['UUID4']>;
  contactInfo: ContactInfo;
  createdOrderSubscriptions: Array<OrderSubscription>;
  /**
   * @deprecated The concept of internal/external order ids is
   * being removed and this will be replaced by a
   * single field.
   *
   */
  externalOrderId?: Maybe<Scalars['String']>;
  fulfillmentSystemOrderId?: Maybe<Scalars['String']>;
  fulfillmentSystemStatus?: Maybe<Scalars['String']>;
  fulfillments?: Maybe<Array<Fulfillment>>;
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  /**
   * @deprecated The concept of internal/external order ids is
   * being removed and this will be replaced by a
   * single field.
   *
   */
  internalOrderId: Scalars['Int'];
  isGift?: Maybe<Scalars['Boolean']>;
  location?: Maybe<LatLong>;
  orderSubscription?: Maybe<OrderSubscription>;
  orderSubscriptionRelationship: OrderSubscriptionRelationshipNames;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentRequest?: Maybe<PaymentRequest>;
  price: Price;
  requestedDeliveryDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type SubmittedOrderPayload = {
  __typename?: 'SubmittedOrderPayload';
  pagination: PaginationData;
  submittedOrders: Array<SubmittedOrder>;
};

export type TaxItem = {
  __typename?: 'TaxItem';
  amount?: Maybe<Scalars['Int']>;
  calculatedTax?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  exempt?: Maybe<Scalars['Int']>;
  impositionTypeId?: Maybe<Scalars['Int']>;
  impositionValue?: Maybe<Scalars['String']>;
  jurisdiction?: Maybe<Scalars['String']>;
  jurisdictionType?: Maybe<Scalars['String']>;
  taxRuleId?: Maybe<Scalars['String']>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  analyticsConfig: AnalyticsConfig;
  /** @deprecated Deprecated in favor of `id`. */
  appId: Scalars['UUID4'];
  brandConfig: BrandConfig;
  capabilities: Capabilities;
  checkout?: Maybe<Checkout>;
  contactConfig: ContactConfig;
  domain: Scalars['String'];
  fallbackUrl: Scalars['String'];
  giftConfig: GiftConfig;
  id: Scalars['UUID4'];
  paymentConfig: PaymentConfig;
  shippingConfig: ShippingConfig;
  shoppingBagConfig: ShoppingBagConfig;
  userExperience: UserExperience;
};

export type TenantPaymentOptions = {
  __typename?: 'TenantPaymentOptions';
  merchantAccountId?: Maybe<Scalars['String']>;
};

export type Tier = {
  __typename?: 'Tier';
  amount: Scalars['Int'];
  minQty: Scalars['Int'];
  type: TierType;
};

export enum TierType {
  /** The tier discounts a flat amount */
  Flat = 'FLAT',
  /** the tier dicounts a percentage amount */
  Percent = 'PERCENT'
}

export type TieredAttributes = {
  __typename?: 'TieredAttributes';
  tiers: Array<Tier>;
};

export type TieredBehaviour = {
  __typename?: 'TieredBehaviour';
  attributes: TieredAttributes;
  name: BehaviourEnum;
};

export type TrackingNumber = {
  __typename?: 'TrackingNumber';
  carrierName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingServiceUpdatedAt?: Maybe<Scalars['NaiveDateTime']>;
  trackingUrl?: Maybe<Scalars['String']>;
};

export type UnitAmount = {
  __typename?: 'UnitAmount';
  amount?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
};

export type UpdateCreditCardDefaultInput = {
  default: Scalars['Boolean'];
  token: Scalars['String'];
};

export type UpdateOrderInput = {
  contactInfo?: InputMaybe<ContactInfoInput>;
  gifteeEmail?: InputMaybe<Scalars['String']>;
  gifteeMessage?: InputMaybe<Scalars['String']>;
  giftorName?: InputMaybe<Scalars['String']>;
  isGift?: InputMaybe<Scalars['Boolean']>;
  paymentRequest?: InputMaybe<PaymentRequestInput>;
  requestedDeliveryDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateOrderSubscriptionAddressInput = {
  addressId: Scalars['UUID4'];
  /** ID of Order Subscription */
  id: Scalars['UUID4'];
};

export type UpdateOrderSubscriptionInput = {
  id: Scalars['UUID4'];
  intervalInDays?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateOrderSubscriptionPaymentInput = {
  /** ID of Order Subscription */
  id: Scalars['UUID4'];
  paymentOptions?: InputMaybe<PaymentOptionsInput>;
};

export type UpdateOrderSubscriptionStatusInput = {
  /** ID of Order Subscription */
  id: Scalars['UUID4'];
  status: OrderSubscriptionStatusNames;
  /** This field is required if status is PAUSED or CANCELED */
  statusReason?: InputMaybe<Scalars['String']>;
};

export type UpdatePaymentMethodDefaultInput = {
  default: Scalars['Boolean'];
  token: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  addresses: Array<Address>;
  /** @deprecated Legacy admin has been disabled, this field is now always false. */
  admin: Scalars['Boolean'];
  appId: Scalars['UUID4'];
  cart?: Maybe<Cart>;
  /** @deprecated Please use paymentMethods going forward. */
  creditCards: Array<CreditCard>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hashedEmail: Scalars['String'];
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  lastLoggedIn?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  paymentMethods?: Maybe<PaymentMethods>;
  userString?: Maybe<Scalars['String']>;
  vendorConfig: Tenant;
};

export type UserAddressInput = {
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  validated?: InputMaybe<Scalars['Boolean']>;
  zip: Scalars['String'];
};

export type UserAddressIsDefaultInput = {
  isDefault: Scalars['Boolean'];
};

export type UserExperience = {
  __typename?: 'UserExperience';
  hasRequestedDeliveryDate: Scalars['Boolean'];
};

export type UserPasswordResetRequestPayload = {
  __typename?: 'UserPasswordResetRequestPayload';
  email: Scalars['String'];
};

export type ValidateZipcodePayload = {
  __typename?: 'ValidateZipcodePayload';
  restrictedItems: Array<Item>;
};

export enum ValidationRequirement {
  Always = 'ALWAYS',
  Optional = 'OPTIONAL'
}

export type VerifyAddressError = {
  __typename?: 'VerifyAddressError';
  code?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  suggestion?: Maybe<Scalars['String']>;
};

export type VerifyAddressInput = {
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type VerifyAddressPayload = {
  __typename?: 'VerifyAddressPayload';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  errors?: Maybe<Array<VerifyAddressError>>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
  zip: Scalars['String'];
};

export type ActiveAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveAccountQuery = { __typename?: 'RootQueryType', activeAccount?: { __typename?: 'Account', type: string, name?: string | null | undefined, tags?: Array<string> | null | undefined, credits: Array<{ __typename?: 'Credit', status: string, type: string, availableAmount: number, spentAmount: number, activeFrom: any, activeUntil?: any | null | undefined, frozen: boolean }>, invoicing?: { __typename?: 'Invoicing', enabled?: boolean | null | undefined, addresses: Array<{ __typename?: 'InvoicedAddress', city: string, company?: string | null | undefined, countryCode: string, id: any, line1: string, line2?: string | null | undefined, state: string, zip: string }> } | null | undefined } | null | undefined };

export type AddressFragment = { __typename?: 'Address', city: string, company?: string | null | undefined, countryCode: string, firstName: string, id: any, lastName: string, line1: string, line2?: string | null | undefined, phoneNumber?: string | null | undefined, state: string, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, zip: string, isDefault?: boolean | null | undefined };

export type AllocationFragment = { __typename?: 'Credit', status: string, type: string, availableAmount: number, spentAmount: number, activeFrom: any, activeUntil?: any | null | undefined, frozen: boolean };

export type CalculateOrderDiscountsMutationVariables = Exact<{
  input: CalculateOrderDiscountsInput;
}>;


export type CalculateOrderDiscountsMutation = { __typename?: 'RootMutationType', calculateOrderDiscounts?: { __typename?: 'CalculateOrderDiscountsPayload', order?: { __typename?: 'Order', price: { __typename?: 'Price', shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', itemId?: any | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, quantity?: number | null | undefined, discountAmount?: number | null | undefined, taxAmount?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined, discount?: { __typename?: 'EmbeddedDiscount', amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined }> } } | null | undefined } | null | undefined };

export type CalculateOrderTaxesCartItemFragment = { __typename?: 'CartItem', id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', id: any, price?: number | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', subscriptionPrice: number } | null | undefined } };

export type CalculateOrderTaxesPriceItemFragment = { __typename?: 'PriceItem', subscriptionIntervalInDays?: number | null | undefined, quantity?: number | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, taxAmount?: number | null | undefined, discountAmount?: number | null | undefined, itemId?: any | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', subscriptionPrice?: number | null | undefined, isSubscribable: boolean } | null | undefined } | null | undefined };

export type CalculateOrderTaxesMutationVariables = Exact<{
  cartId: Scalars['UUID4'];
  contactInfo: ContactInfoInput;
  orderId: Scalars['UUID4'];
  paymentRequest: PaymentRequestInput;
  price: PriceInput;
  invoiceAddressId?: InputMaybe<Scalars['UUID4']>;
}>;


export type CalculateOrderTaxesMutation = { __typename?: 'RootMutationType', calculateOrderTaxes?: { __typename?: 'CalculateOrderPayload', order?: { __typename?: 'Order', appId?: any | null | undefined, id: any, status?: string | null | undefined, internalOrderId: number, externalOrderId?: string | null | undefined, cart?: { __typename?: 'Cart', id: any, items: Array<{ __typename?: 'CartItem', id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', id: any, price?: number | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', subscriptionPrice: number } | null | undefined } }> } | null | undefined, contactInfo: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'EmbeddedAddress', firstName?: string | null | undefined, lastName?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined } | null | undefined }, paymentRequest?: { __typename?: 'PaymentRequest', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: string | null | undefined, billingAddress?: { __typename?: 'EmbeddedAddress', firstName?: string | null | undefined, lastName?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined } | null | undefined } | null | undefined, price: { __typename?: 'Price', id?: any | null | undefined, shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, calculatedTax?: number | null | undefined, description?: string | null | undefined, taxRuleId?: string | null | undefined, exempt?: number | null | undefined, impositionTypeId?: number | null | undefined, impositionValue?: string | null | undefined, jurisdiction?: string | null | undefined, jurisdictionType?: string | null | undefined }>, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', subscriptionIntervalInDays?: number | null | undefined, quantity?: number | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, taxAmount?: number | null | undefined, discountAmount?: number | null | undefined, itemId?: any | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', subscriptionPrice?: number | null | undefined, isSubscribable: boolean } | null | undefined } | null | undefined }> } } | null | undefined } | null | undefined };

export type CartFragment = { __typename?: 'Cart', id: any, appId: any, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', id: any, quantity: number, analyticsDetails?: any | null | undefined, subscriptionIntervalInDays?: number | null | undefined, customizations?: any | null | undefined, product: { __typename?: 'Item', id: any, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } }> };

export type CartRecoveryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CartRecoveryQuery = { __typename?: 'RootQueryType', cartRecovery?: { __typename?: 'Cart', id: any, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined };

export type ChangeUserPasswordMutationVariables = Exact<{
  input: ChangeUserPasswordInput;
}>;


export type ChangeUserPasswordMutation = { __typename?: 'RootMutationType', changeUserPassword?: { __typename?: 'User', id: any } | null | undefined };

export type CreateOrderMutationVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type CreateOrderMutation = { __typename?: 'RootMutationType', createOrder?: { __typename?: 'CreatedOrder', id: any, status?: string | null | undefined, requestedDeliveryDate?: any | null | undefined, submissionUid?: string | null | undefined, cart?: { __typename?: 'Cart', id: any, appId: any, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', id: any, quantity: number, analyticsDetails?: any | null | undefined, subscriptionIntervalInDays?: number | null | undefined, customizations?: any | null | undefined, product: { __typename?: 'Item', id: any, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } }> } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, paymentRequest?: { __typename?: 'PaymentRequest', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: string | null | undefined, billingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, price: { __typename?: 'Price', shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', itemId?: any | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, quantity?: number | null | undefined, discountAmount?: number | null | undefined, taxAmount?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined, discount?: { __typename?: 'EmbeddedDiscount', amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined }> } } | null | undefined };

export type CreatePaymentClientTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreatePaymentClientTokenMutation = { __typename?: 'RootMutationType', createPaymentClientToken: { __typename?: 'PaymentClientTokenPayload', token: string } };

export type CreatePaymentMethodMutationVariables = Exact<{
  input: CreatePaymentMethodInput;
}>;


export type CreatePaymentMethodMutation = { __typename?: 'RootMutationType', createPaymentMethod: { __typename: 'CreditCard' } | { __typename: 'PaypalAccount' } };

export type CreateUserAddressMutationVariables = Exact<{
  input: UserAddressInput;
}>;


export type CreateUserAddressMutation = { __typename?: 'RootMutationType', createUserAddress: { __typename?: 'Address', id: any } };

export type CreditCardFragment = { __typename?: 'CreditCard', cardType: string, cardholderName?: string | null | undefined, createdAt: string, expirationMonth: string, expirationYear: string, default: boolean, last4: string, token: string, uniqueNumberIdentifier: string, billingAddress?: { __typename?: 'BraintreeAddress', company?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, streetAddress?: string | null | undefined, extendedAddress?: string | null | undefined, locality?: string | null | undefined, region?: string | null | undefined, postalCode?: string | null | undefined, countryCodeAlpha2?: string | null | undefined } | null | undefined };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any, insertedAt: any, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, userString?: string | null | undefined, addresses: Array<{ __typename?: 'Address', city: string, company?: string | null | undefined, countryCode: string, firstName: string, id: any, lastName: string, line1: string, line2?: string | null | undefined, phoneNumber?: string | null | undefined, state: string, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, zip: string, isDefault?: boolean | null | undefined }>, paymentMethods?: { __typename?: 'PaymentMethods', creditCards?: Array<{ __typename?: 'CreditCard', cardType: string, cardholderName?: string | null | undefined, createdAt: string, expirationMonth: string, expirationYear: string, default: boolean, last4: string, token: string, uniqueNumberIdentifier: string, billingAddress?: { __typename?: 'BraintreeAddress', company?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, streetAddress?: string | null | undefined, extendedAddress?: string | null | undefined, locality?: string | null | undefined, region?: string | null | undefined, postalCode?: string | null | undefined, countryCodeAlpha2?: string | null | undefined } | null | undefined }> | null | undefined, paypalAccounts?: Array<{ __typename?: 'PaypalAccount', billingAgreementId: string, createdAt: string, customerId: string, default: boolean, email: string, imageUrl: string, token: string }> | null | undefined } | null | undefined } | null | undefined };

export type CurrentUserIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserIdQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any } | null | undefined };

export type CurrentUserPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserPaymentMethodsQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any, paymentMethods?: { __typename?: 'PaymentMethods', creditCards?: Array<{ __typename?: 'CreditCard', default: boolean }> | null | undefined, paypalAccounts?: Array<{ __typename?: 'PaypalAccount', default: boolean }> | null | undefined } | null | undefined } | null | undefined };

export type DeleteCreditCardMutationVariables = Exact<{
  input: DeleteCreditCardInput;
}>;


export type DeleteCreditCardMutation = { __typename?: 'RootMutationType', deleteCreditCard: string };

export type DeletePaymentMethodMutationVariables = Exact<{
  input: DeletePaymentMethodInput;
}>;


export type DeletePaymentMethodMutation = { __typename?: 'RootMutationType', deletePaymentMethod: string };

export type DeleteUserAddressMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type DeleteUserAddressMutation = { __typename?: 'RootMutationType', deleteUserAddress: { __typename?: 'Address', id: any } };

export type DiscountFragment = { __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined };

export type EmbeddedAddressFragment = { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined };

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagsQuery = { __typename?: 'RootQueryType', featureFlags: Array<{ __typename?: 'FeatureFlag', name: string, enabled: boolean }> };

export type FindAddressQueryVariables = Exact<{
  input: FindAddressInput;
}>;


export type FindAddressQuery = { __typename?: 'RootQueryType', findAddress?: { __typename?: 'FoundItems', items?: Array<{ __typename?: 'FoundAddress', id?: string | null | undefined, value?: string | null | undefined, description?: string | null | undefined, type?: string | null | undefined }> | null | undefined } | null | undefined };

export type InvoicedAddressFragment = { __typename?: 'InvoicedAddress', city: string, company?: string | null | undefined, countryCode: string, id: any, line1: string, line2?: string | null | undefined, state: string, zip: string };

export type LoginUserMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginUserMutation = { __typename?: 'RootMutationType', loginUser?: { __typename?: 'User', id: any } | null | undefined };

export type LogoutUserMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutUserMutation = { __typename?: 'RootMutationType', logoutUser?: { __typename?: 'User', id: any } | null | undefined };

export type PaypalAccountFragment = { __typename?: 'PaypalAccount', billingAgreementId: string, createdAt: string, customerId: string, default: boolean, email: string, imageUrl: string, token: string };

export type PriceFragment = { __typename?: 'Price', shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', itemId?: any | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, quantity?: number | null | undefined, discountAmount?: number | null | undefined, taxAmount?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined, discount?: { __typename?: 'EmbeddedDiscount', amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined }> };

export type PriceItemFragment = { __typename?: 'PriceItem', itemId?: any | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, quantity?: number | null | undefined, discountAmount?: number | null | undefined, taxAmount?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined, discount?: { __typename?: 'EmbeddedDiscount', amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type RequestPasswordResetForUserMutationVariables = Exact<{
  input: RequestPasswordResetForUserInput;
}>;


export type RequestPasswordResetForUserMutation = { __typename?: 'RootMutationType', requestPasswordResetForUser?: { __typename?: 'RequestPasswordResetForUserPayload', email: string } | null | undefined };

export type ResetUserPasswordMutationVariables = Exact<{
  input: ResetUserPasswordInput;
}>;


export type ResetUserPasswordMutation = { __typename?: 'RootMutationType', resetUserPassword?: { __typename?: 'User', id: any } | null | undefined };

export type RestrictedItemsByZipCodeQueryVariables = Exact<{
  zip: Scalars['String'];
}>;


export type RestrictedItemsByZipCodeQuery = { __typename?: 'RootQueryType', restrictedItemsByZipCode?: { __typename?: 'RestrictedItemsByZipCodePayload', restrictedItems: Array<{ __typename?: 'Item', id: any }> } | null | undefined };

export type RetrieveAddressQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type RetrieveAddressQuery = { __typename?: 'RootQueryType', retrieveAddress?: { __typename?: 'RetrievedItems', items?: Array<{ __typename?: 'RetrievedAddress', line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, country?: string | null | undefined }> | null | undefined } | null | undefined };

export type SearchDiscountsQueryVariables = Exact<{
  input: SearchDiscountsInput;
}>;


export type SearchDiscountsQuery = { __typename?: 'RootQueryType', searchDiscounts?: { __typename?: 'Discounts', discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }> | null | undefined } | null | undefined };

export type SignUpUserMutationVariables = Exact<{
  activationCode: Scalars['String'];
  activationCodeRequired?: InputMaybe<Scalars['Boolean']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
}>;


export type SignUpUserMutation = { __typename?: 'RootMutationType', signupUser?: { __typename?: 'User', id: any, hashedEmail: string } | null | undefined };

export type SkipOrderSubscriptionMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type SkipOrderSubscriptionMutation = { __typename?: 'RootMutationType', skipOrderSubscription?: { __typename?: 'OrderSubscription', id: any } | null | undefined };

export type SubmitOrderMutationVariables = Exact<{
  orderId: Scalars['String'];
  input: SubmitOrderInput;
}>;


export type SubmitOrderMutation = { __typename?: 'RootMutationType', submitOrder?: { __typename?: 'SubmittedOrder', id: any, appId?: any | null | undefined, requestedDeliveryDate?: any | null | undefined, submissionUid?: string | null | undefined, contactInfo: { __typename?: 'ContactInfo', email?: string | null | undefined, userString?: string | null | undefined, phone?: string | null | undefined, username?: string | null | undefined, bazaarvoice?: { __typename?: 'Bazaarvoice', encryptedEmail?: string | null | undefined, encryptionKeyId?: string | null | undefined } | null | undefined, shippingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined }, paymentRequest?: { __typename?: 'PaymentRequest', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: string | null | undefined, billingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, price: { __typename?: 'Price', shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, items: Array<{ __typename?: 'PriceItem', id: any, itemId?: any | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, quantity?: number | null | undefined, discountAmount?: number | null | undefined, taxAmount?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined, discount?: { __typename?: 'EmbeddedDiscount', amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined }> } } | null | undefined };

export type SubmittedOrderQueryVariables = Exact<{
  orderId: Scalars['UUID4'];
}>;


export type SubmittedOrderQuery = { __typename?: 'RootQueryType', submittedOrder?: { __typename?: 'SubmittedOrder', externalOrderId?: string | null | undefined, submittedAt?: any | null | undefined, requestedDeliveryDate?: any | null | undefined, contactInfo: { __typename?: 'ContactInfo', shippingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined }, paymentRequest?: { __typename?: 'PaymentRequest', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: string | null | undefined, billingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, paymentInfo?: { __typename?: 'PaymentInfo', cardExpirationDate?: string | null | undefined, cardholderName?: string | null | undefined, email?: string | null | undefined, externalId?: string | null | undefined, last4?: string | null | undefined, paymentMethod?: PaymentMethodNames | null | undefined, paymentType?: string | null | undefined, paypalEmail?: string | null | undefined, uniqueNumberIdentifier?: string | null | undefined } | null | undefined, price: { __typename?: 'Price', shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, discount?: number | null | undefined, total?: number | null | undefined, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', basePrice?: number | null | undefined, discountAmount?: number | null | undefined, quantity?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', id?: any | null | undefined, price?: number | null | undefined, compareAtPrice?: number | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', subscriptionPrice?: number | null | undefined } | null | undefined } | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionValue?: string | null | undefined, impositionTypeId?: number | null | undefined }> }, fulfillments?: Array<{ __typename?: 'Fulfillment', status?: string | null | undefined, trackingNumber?: string | null | undefined, trackingNumbers: Array<{ __typename?: 'TrackingNumber', carrierName?: string | null | undefined, status?: string | null | undefined, trackingNumber?: string | null | undefined, trackingUrl?: string | null | undefined }>, items: Array<{ __typename?: 'FulfillmentItem', quantity?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'Item', id: any, title?: string | null | undefined, price?: number | null | undefined, imgUrl?: string | null | undefined, productsPerPack?: number | null | undefined, fluidOzPerPack?: any | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number } | null | undefined } | null | undefined }> }> | null | undefined } | null | undefined };

export type SubmittedOrderForOrderConfirmationQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type SubmittedOrderForOrderConfirmationQuery = { __typename?: 'RootQueryType', submittedOrder?: { __typename?: 'SubmittedOrder', id: any, externalOrderId?: string | null | undefined, submittedAt?: any | null | undefined, giftorName?: string | null | undefined, price: { __typename?: 'Price', shipping?: number | null | undefined, subtotal?: number | null | undefined, total?: number | null | undefined, tax?: number | null | undefined, discount?: number | null | undefined, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', impositionTypeId?: number | null | undefined, impositionValue?: string | null | undefined, amount?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', id: any, customizations?: any | null | undefined, subscriptionIntervalInDays?: number | null | undefined, quantity?: number | null | undefined, basePrice?: number | null | undefined, discountAmount?: number | null | undefined, taxAmount?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', title?: string | null | undefined, price?: number | null | undefined, compareAtPrice?: number | null | undefined, imgUrl?: string | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', subscriptionPrice?: number | null | undefined, isSubscribable: boolean } | null | undefined } | null | undefined }> }, fulfillments?: Array<{ __typename?: 'Fulfillment', id: any, carrierName?: string | null | undefined, trackingNumber?: string | null | undefined, insertedAt?: any | null | undefined, status?: string | null | undefined, trackingNumbers: Array<{ __typename?: 'TrackingNumber', status?: string | null | undefined, trackingNumber?: string | null | undefined, trackingUrl?: string | null | undefined }>, items: Array<{ __typename?: 'FulfillmentItem', quantity?: number | null | undefined, item?: { __typename?: 'Item', id: any, title?: string | null | undefined, imgUrl?: string | null | undefined } | null | undefined }> }> | null | undefined, paymentInfo?: { __typename?: 'PaymentInfo', last4?: string | null | undefined, paymentType?: string | null | undefined, cardExpirationDate?: string | null | undefined } | null | undefined, contactInfo: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined }, paymentRequest?: { __typename?: 'PaymentRequest', paymentMethod?: string | null | undefined, isBillingEqualShipping?: boolean | null | undefined, billingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type SubmittedOrdersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type SubmittedOrdersQuery = { __typename?: 'RootQueryType', submittedOrders: { __typename?: 'SubmittedOrderPayload', pagination: { __typename?: 'PaginationData', totalPages: number }, submittedOrders: Array<{ __typename?: 'SubmittedOrder', id: any, orderSubscriptionRelationship: OrderSubscriptionRelationshipNames, externalOrderId?: string | null | undefined, submittedAt?: any | null | undefined, requestedDeliveryDate?: any | null | undefined, price: { __typename?: 'Price', total?: number | null | undefined }, contactInfo: { __typename?: 'ContactInfo', shippingAddress?: { __typename?: 'EmbeddedAddress', nickname?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined } | null | undefined }, fulfillments?: Array<{ __typename?: 'Fulfillment', id: any }> | null | undefined }> } };

export type SubscriptionQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type SubscriptionQuery = { __typename?: 'RootQueryType', orderSubscription?: { __typename?: 'OrderSubscription', id: any, canceledAt?: any | null | undefined, title: string, insertedAt: any, nextDeliveryDate: any, nextOrderCreationDates: Array<any | null | undefined>, status: OrderSubscriptionStatusNames, statusReason?: string | null | undefined, intervalInDays: number, address: { __typename?: 'Address', city: string, firstName: string, id: any, lastName: string, line1: string, line2?: string | null | undefined, state: string, zip: string }, user: { __typename?: 'User', paymentMethods?: { __typename?: 'PaymentMethods', creditCards?: Array<{ __typename?: 'CreditCard', last4: string, expirationMonth: string, expirationYear: string, cardholderName?: string | null | undefined, cardType: string }> | null | undefined, paypalAccounts?: Array<{ __typename?: 'PaypalAccount', email: string }> | null | undefined } | null | undefined }, paymentInfo: { __typename?: 'PaymentInfo', uniqueNumberIdentifier?: string | null | undefined, paymentMethod?: PaymentMethodNames | null | undefined, email?: string | null | undefined, last4?: string | null | undefined }, orderSubscriptionItems: Array<{ __typename?: 'OrderSubscriptionItem', priceItem: { __typename?: 'PriceItem', subscriptionIntervalInDays?: number | null | undefined, basePrice?: number | null | undefined, quantity?: number | null | undefined, price?: { __typename?: 'Price', total?: number | null | undefined, discount?: number | null | undefined, shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined, impositionValue?: string | null | undefined }> } | null | undefined, item?: { __typename?: 'EmbeddedItem', id?: any | null | undefined, imgUrl?: string | null | undefined, title?: string | null | undefined, fluidOzPerPack?: any | null | undefined, productsPerPack?: number | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', subscriptionPrice?: number | null | undefined, isSubscribable: boolean } | null | undefined } | null | undefined } }>, originatingOrder?: { __typename?: 'SubmittedOrder', price: { __typename?: 'Price', shipping?: number | null | undefined } } | null | undefined } | null | undefined };

export type SubscriptionAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionAddressesQuery = { __typename?: 'RootQueryType', orderSubscriptions?: { __typename?: 'OrderSubscriptionsPayload', orderSubscriptions: Array<{ __typename?: 'OrderSubscription', address: { __typename?: 'Address', id: any } }> } | null | undefined };

export type SubscriptionForAddressUpdateQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type SubscriptionForAddressUpdateQuery = { __typename?: 'RootQueryType', orderSubscription?: { __typename?: 'OrderSubscription', id: any, title: string, address: { __typename?: 'Address', id: any }, orderSubscriptionItems: Array<{ __typename?: 'OrderSubscriptionItem', priceItem: { __typename?: 'PriceItem', currentItem?: { __typename?: 'Item', id: any } | null | undefined } }> } | null | undefined };

export type SubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionsQuery = { __typename?: 'RootQueryType', orderSubscriptions?: { __typename?: 'OrderSubscriptionsPayload', orderSubscriptions: Array<{ __typename?: 'OrderSubscription', id: any, title: string, intervalInDays: number, insertedAt: any, nextDeliveryDate: any, status: OrderSubscriptionStatusNames, statusReason?: string | null | undefined, orderSubscriptionItems: Array<{ __typename?: 'OrderSubscriptionItem', priceItem: { __typename?: 'PriceItem', currentItem?: { __typename?: 'Item', imgUrl?: string | null | undefined } | null | undefined } }> }> } | null | undefined };

export type TenantQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantQuery = { __typename?: 'RootQueryType', tenant?: { __typename?: 'Tenant', id: any, domain: string, fallbackUrl: string, analyticsConfig: { __typename?: 'AnalyticsConfig', projectId?: string | null | undefined, writeKey?: string | null | undefined, gtm?: { __typename?: 'GtmConfig', containerId?: string | null | undefined } | null | undefined }, brandConfig: { __typename?: 'BrandConfig', customCss?: string | null | undefined, audience: string, copyright: string, optInText: string, contactUrl?: string | null | undefined, email?: string | null | undefined, logoUrl: string, title: string, yearsAgeGate?: number | null | undefined, customizations: { __typename?: 'BrandConfigCustomizations', contacts: Array<{ __typename?: 'BrandConfigCustomizationsContact', city?: string | null | undefined, countryCode?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, phoneNumber?: string | null | undefined, state?: string | null | undefined, type: string, zip?: string | null | undefined }>, fonts: Array<{ __typename?: 'BrandConfigCustomizationsFont', name: string, style?: string | null | undefined, weight?: string | null | undefined, urls: Array<{ __typename?: 'BrandConfigCustomizationsFontSources', format?: string | null | undefined, local?: string | null | undefined, url?: string | null | undefined }>, meta?: Array<{ __typename?: 'BrandConfigCustomizationsFontMeta', key: string, value: string }> | null | undefined }>, images: Array<{ __typename?: 'BrandConfigCustomizationsImage', name: string, src: string, alt?: string | null | undefined }>, links: Array<{ __typename?: 'BrandConfigCustomizationsLink', location: string, position: number, title: string, url: string, newTab: boolean }> }, trackingFonts?: Array<{ __typename?: 'BrandConfigTrackingFonts', isTrackingRequired: boolean, resource: string } | null | undefined> | null | undefined }, capabilities: { __typename?: 'Capabilities', signUp: { __typename?: 'CapabilitiesSignUp', enabled: boolean } }, giftConfig: { __typename?: 'GiftConfig', giftingEnabled?: boolean | null | undefined }, contactConfig: { __typename?: 'ContactConfig', shippingAddressConfig: { __typename?: 'AddressConfig', requireValidation: ValidationRequirement, note?: string | null | undefined, countriesAllowed: Array<{ __typename?: 'CountriesAllowed', id: string, name: string }>, statesConfig: Array<{ __typename?: 'StatesConfig', countryId: string, statesAllowed: Array<{ __typename?: 'AllowedState', id: string, name: string }> }> } }, paymentConfig: { __typename?: 'PaymentConfig', billingAddressConfig: { __typename?: 'AddressConfig', requireValidation: ValidationRequirement, note?: string | null | undefined, countriesAllowed: Array<{ __typename?: 'CountriesAllowed', id: string, name: string }>, statesConfig: Array<{ __typename?: 'StatesConfig', countryId: string, statesAllowed: Array<{ __typename?: 'AllowedState', id: string, name: string }> }> }, paymentTypes: Array<{ __typename?: 'PaymentType', brandImgUrl: string, id: number, name: string }> }, shippingConfig: { __typename?: 'ShippingConfig', maxDeliveryWindowInDays?: number | null | undefined }, shoppingBagConfig: { __typename?: 'ShoppingBagConfig', maxAmountForSelect: number, minimumPurchaseAmount: number, minimumPurchaseQty: number, availableSubscriptionIntervalsInDays: Array<number>, orderSubscriptionsEnabled: boolean, subscriptionIntervalsInDays: Array<number> }, userExperience: { __typename?: 'UserExperience', hasRequestedDeliveryDate: boolean } } | null | undefined };

export type UpdateCartItemMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID4']>;
  itemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: InputMaybe<Scalars['Int']>;
  customizations?: InputMaybe<Scalars['Json']>;
}>;


export type UpdateCartItemMutation = { __typename?: 'RootMutationType', updateCartItem?: { __typename?: 'Cart', id: any, appId: any, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', id: any, quantity: number, analyticsDetails?: any | null | undefined, subscriptionIntervalInDays?: number | null | undefined, customizations?: any | null | undefined, product: { __typename?: 'Item', id: any, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } }> } | null | undefined };

export type UpdateCreditCardDefaultMutationVariables = Exact<{
  input: UpdateCreditCardDefaultInput;
}>;


export type UpdateCreditCardDefaultMutation = { __typename?: 'RootMutationType', updateCreditCardDefault: { __typename?: 'CreditCard', default: boolean } };

export type UpdateOrderMutationVariables = Exact<{
  orderId: Scalars['UUID4'];
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'RootMutationType', updateOrder?: { __typename?: 'CreatedOrder', id: any, status?: string | null | undefined, requestedDeliveryDate?: any | null | undefined, submissionUid?: string | null | undefined, cart?: { __typename?: 'Cart', id: any, appId: any, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', id: any, quantity: number, analyticsDetails?: any | null | undefined, subscriptionIntervalInDays?: number | null | undefined, customizations?: any | null | undefined, product: { __typename?: 'Item', id: any, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } }> } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, paymentRequest?: { __typename?: 'PaymentRequest', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: string | null | undefined, billingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateOrderSubscriptionAddressMutationVariables = Exact<{
  input: UpdateOrderSubscriptionAddressInput;
}>;


export type UpdateOrderSubscriptionAddressMutation = { __typename?: 'RootMutationType', updateOrderSubscriptionAddress?: { __typename?: 'OrderSubscription', id: any } | null | undefined };

export type UpdateOrderSubscriptionPaymentMutationVariables = Exact<{
  input: UpdateOrderSubscriptionPaymentInput;
}>;


export type UpdateOrderSubscriptionPaymentMutation = { __typename?: 'RootMutationType', updateOrderSubscriptionPayment?: { __typename?: 'OrderSubscription', id: any } | null | undefined };

export type UpdateSubscriptionMutationVariables = Exact<{
  input: UpdateOrderSubscriptionInput;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'RootMutationType', updateOrderSubscription?: { __typename?: 'OrderSubscription', id: any, title: string } | null | undefined };

export type UpdateSubscriptionStatusMutationVariables = Exact<{
  input: UpdateOrderSubscriptionStatusInput;
}>;


export type UpdateSubscriptionStatusMutation = { __typename?: 'RootMutationType', updateOrderSubscriptionStatus?: { __typename?: 'OrderSubscription', id: any } | null | undefined };

export type UpdateUserAddressMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: UserAddressInput;
}>;


export type UpdateUserAddressMutation = { __typename?: 'RootMutationType', updateUserAddress: { __typename?: 'Address', id: any } };

export type UpdateUserAddressDefaultMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: UserAddressIsDefaultInput;
}>;


export type UpdateUserAddressDefaultMutation = { __typename?: 'RootMutationType', updateUserAddressIsDefault: { __typename?: 'Address', id: any } };

export type UserAddressVerificationMutationVariables = Exact<{
  input: VerifyAddressInput;
}>;


export type UserAddressVerificationMutation = { __typename?: 'RootMutationType', userAddressVerification?: { __typename?: 'VerifyAddressPayload', firstName: string, lastName: string, company?: string | null | undefined, countryCode: string, city: string, state: string, zip: string, line1: string, line2?: string | null | undefined, success?: boolean | null | undefined, errors?: Array<{ __typename?: 'VerifyAddressError', code?: string | null | undefined, field?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type VerifiedAddressFragment = { __typename?: 'VerifyAddressPayload', firstName: string, lastName: string, company?: string | null | undefined, countryCode: string, city: string, state: string, zip: string, line1: string, line2?: string | null | undefined, success?: boolean | null | undefined, errors?: Array<{ __typename?: 'VerifyAddressError', code?: string | null | undefined, field?: string | null | undefined, message?: string | null | undefined }> | null | undefined };

export type VerifyAddressForOrderMutationVariables = Exact<{
  input: VerifyAddressInput;
  orderId: Scalars['String'];
}>;


export type VerifyAddressForOrderMutation = { __typename?: 'RootMutationType', verifyAddressForOrder?: { __typename?: 'VerifyAddressPayload', firstName: string, lastName: string, company?: string | null | undefined, countryCode: string, city: string, state: string, zip: string, line1: string, line2?: string | null | undefined, success?: boolean | null | undefined, errors?: Array<{ __typename?: 'VerifyAddressError', code?: string | null | undefined, field?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export const AddressFragmentDoc = gql`
    fragment Address on Address {
  city
  company
  countryCode
  firstName
  id
  lastName
  line1
  line2
  phoneNumber
  state
  nickname
  specialInstructions
  zip
  isDefault
}
    `;
export const AllocationFragmentDoc = gql`
    fragment Allocation on Credit {
  status
  type
  availableAmount
  spentAmount
  activeFrom
  activeUntil
  frozen
}
    `;
export const CalculateOrderTaxesCartItemFragmentDoc = gql`
    fragment CalculateOrderTaxesCartItem on CartItem {
  id
  quantity
  subscriptionIntervalInDays
  item {
    id
    price
    subscriptionMetadata {
      subscriptionPrice
    }
  }
}
    `;
export const CalculateOrderTaxesPriceItemFragmentDoc = gql`
    fragment CalculateOrderTaxesPriceItem on PriceItem {
  subscriptionIntervalInDays
  quantity
  basePrice
  compareAtPrice
  taxAmount
  discountAmount
  itemId
  item {
    price
    subscriptionMetadata {
      subscriptionPrice
      isSubscribable
    }
  }
}
    `;
export const CartFragmentDoc = gql`
    fragment Cart on Cart {
  id
  appId
  user {
    id
  }
  items {
    id
    quantity
    analyticsDetails
    product: item {
      id
      itemSlug: slug
      title
      brandName
      imgUrl
      price
      isOutOfStock
      minOrderQty
      inventoryQty
      compareAtPrice
      subscriptionMetadata {
        discount {
          id
          activeFrom
          amount
          isPercent
        }
        isSubscribable
        subscriptionPrice
      }
      subItems {
        imgUrl
        title
      }
    }
    subscriptionIntervalInDays
    customizations
  }
}
    `;
export const CreditCardFragmentDoc = gql`
    fragment CreditCard on CreditCard {
  billingAddress {
    company
    firstName
    lastName
    streetAddress
    extendedAddress
    locality
    region
    postalCode
    countryCodeAlpha2
  }
  cardType
  cardholderName
  createdAt
  expirationMonth
  expirationYear
  default
  last4
  token
  uniqueNumberIdentifier
}
    `;
export const EmbeddedAddressFragmentDoc = gql`
    fragment EmbeddedAddress on EmbeddedAddress {
  city
  company
  countryCode
  firstName
  lastName
  line1
  line2
  nickname
  specialInstructions
  state
  validated
  zip
}
    `;
export const InvoicedAddressFragmentDoc = gql`
    fragment InvoicedAddress on InvoicedAddress {
  city
  company
  countryCode
  id
  line1
  line2
  state
  zip
}
    `;
export const PaypalAccountFragmentDoc = gql`
    fragment PaypalAccount on PaypalAccount {
  billingAgreementId
  createdAt
  customerId
  default
  email
  imageUrl
  token
}
    `;
export const DiscountFragmentDoc = gql`
    fragment Discount on Discount {
  id
  activeFrom
  activeUntil
  amount
  appId
  isPercent
  isPromoCodeRequired
  limit
  promoCode
  type
  typeDependentValue
  usage
}
    `;
export const PriceItemFragmentDoc = gql`
    fragment PriceItem on PriceItem {
  itemId
  item {
    price
    subscriptionMetadata {
      discount {
        amount
        isPercent
      }
      isSubscribable
      subscriptionPrice
    }
  }
  basePrice
  compareAtPrice
  quantity
  discountAmount
  taxAmount
  subscriptionIntervalInDays
}
    `;
export const PriceFragmentDoc = gql`
    fragment Price on Price {
  discounts {
    ...Discount
  }
  items {
    ...PriceItem
  }
  shipping
  subtotal
  tax
  taxItems {
    amount
    impositionTypeId
  }
  total
}
    ${DiscountFragmentDoc}
${PriceItemFragmentDoc}`;
export const VerifiedAddressFragmentDoc = gql`
    fragment VerifiedAddress on VerifyAddressPayload {
  firstName
  lastName
  company
  countryCode
  city
  state
  zip
  line1
  line2
  success
  errors {
    code
    field
    message
  }
}
    `;
export const ActiveAccountDocument = gql`
    query ActiveAccount {
  activeAccount {
    type
    name
    tags
    credits {
      ...Allocation
    }
    invoicing {
      enabled
      addresses {
        ...InvoicedAddress
      }
    }
  }
}
    ${AllocationFragmentDoc}
${InvoicedAddressFragmentDoc}`;

/**
 * __useActiveAccountQuery__
 *
 * To run a query within a React component, call `useActiveAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveAccountQuery, ActiveAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveAccountQuery, ActiveAccountQueryVariables>(ActiveAccountDocument, options);
      }
export function useActiveAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveAccountQuery, ActiveAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveAccountQuery, ActiveAccountQueryVariables>(ActiveAccountDocument, options);
        }
export type ActiveAccountQueryHookResult = ReturnType<typeof useActiveAccountQuery>;
export type ActiveAccountLazyQueryHookResult = ReturnType<typeof useActiveAccountLazyQuery>;
export type ActiveAccountQueryResult = Apollo.QueryResult<ActiveAccountQuery, ActiveAccountQueryVariables>;
export const CalculateOrderDiscountsDocument = gql`
    mutation CalculateOrderDiscounts($input: CalculateOrderDiscountsInput!) {
  calculateOrderDiscounts(input: $input) {
    order {
      price {
        ...Price
      }
    }
  }
}
    ${PriceFragmentDoc}`;
export type CalculateOrderDiscountsMutationFn = Apollo.MutationFunction<CalculateOrderDiscountsMutation, CalculateOrderDiscountsMutationVariables>;

/**
 * __useCalculateOrderDiscountsMutation__
 *
 * To run a mutation, you first call `useCalculateOrderDiscountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateOrderDiscountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateOrderDiscountsMutation, { data, loading, error }] = useCalculateOrderDiscountsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateOrderDiscountsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CalculateOrderDiscountsMutation, CalculateOrderDiscountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CalculateOrderDiscountsMutation, CalculateOrderDiscountsMutationVariables>(CalculateOrderDiscountsDocument, options);
      }
export type CalculateOrderDiscountsMutationHookResult = ReturnType<typeof useCalculateOrderDiscountsMutation>;
export type CalculateOrderDiscountsMutationResult = Apollo.MutationResult<CalculateOrderDiscountsMutation>;
export type CalculateOrderDiscountsMutationOptions = Apollo.BaseMutationOptions<CalculateOrderDiscountsMutation, CalculateOrderDiscountsMutationVariables>;
export const CalculateOrderTaxesDocument = gql`
    mutation CalculateOrderTaxes($cartId: UUID4!, $contactInfo: ContactInfoInput!, $orderId: UUID4!, $paymentRequest: PaymentRequestInput!, $price: PriceInput!, $invoiceAddressId: UUID4) {
  calculateOrderTaxes(
    cartId: $cartId
    contactInfo: $contactInfo
    orderId: $orderId
    paymentRequest: $paymentRequest
    price: $price
    invoiceAddressId: $invoiceAddressId
  ) {
    order {
      appId
      id
      status
      internalOrderId
      externalOrderId
      cart {
        id
        items {
          ...CalculateOrderTaxesCartItem
        }
      }
      contactInfo {
        email
        phone
        shippingAddress {
          firstName
          lastName
          company
          countryCode
          city
          state
          zip
          line1
          line2
        }
      }
      paymentRequest {
        isBillingEqualShipping
        paymentMethod
        billingAddress {
          firstName
          lastName
          company
          countryCode
          city
          state
          zip
          line1
          line2
        }
      }
      price {
        id
        taxItems {
          amount
          calculatedTax
          description
          taxRuleId
          exempt
          impositionTypeId
          impositionValue
          jurisdiction
          jurisdictionType
        }
        shipping
        subtotal
        tax
        total
        discounts {
          ...Discount
        }
        items {
          ...CalculateOrderTaxesPriceItem
        }
      }
    }
  }
}
    ${CalculateOrderTaxesCartItemFragmentDoc}
${DiscountFragmentDoc}
${CalculateOrderTaxesPriceItemFragmentDoc}`;
export type CalculateOrderTaxesMutationFn = Apollo.MutationFunction<CalculateOrderTaxesMutation, CalculateOrderTaxesMutationVariables>;

/**
 * __useCalculateOrderTaxesMutation__
 *
 * To run a mutation, you first call `useCalculateOrderTaxesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateOrderTaxesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateOrderTaxesMutation, { data, loading, error }] = useCalculateOrderTaxesMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      contactInfo: // value for 'contactInfo'
 *      orderId: // value for 'orderId'
 *      paymentRequest: // value for 'paymentRequest'
 *      price: // value for 'price'
 *      invoiceAddressId: // value for 'invoiceAddressId'
 *   },
 * });
 */
export function useCalculateOrderTaxesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CalculateOrderTaxesMutation, CalculateOrderTaxesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CalculateOrderTaxesMutation, CalculateOrderTaxesMutationVariables>(CalculateOrderTaxesDocument, options);
      }
export type CalculateOrderTaxesMutationHookResult = ReturnType<typeof useCalculateOrderTaxesMutation>;
export type CalculateOrderTaxesMutationResult = Apollo.MutationResult<CalculateOrderTaxesMutation>;
export type CalculateOrderTaxesMutationOptions = Apollo.BaseMutationOptions<CalculateOrderTaxesMutation, CalculateOrderTaxesMutationVariables>;
export const CartRecoveryDocument = gql`
    query CartRecovery($id: String!) {
  cartRecovery(id: $id) {
    id
    user {
      id
    }
  }
}
    `;

/**
 * __useCartRecoveryQuery__
 *
 * To run a query within a React component, call `useCartRecoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartRecoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartRecoveryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCartRecoveryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CartRecoveryQuery, CartRecoveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CartRecoveryQuery, CartRecoveryQueryVariables>(CartRecoveryDocument, options);
      }
export function useCartRecoveryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CartRecoveryQuery, CartRecoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CartRecoveryQuery, CartRecoveryQueryVariables>(CartRecoveryDocument, options);
        }
export type CartRecoveryQueryHookResult = ReturnType<typeof useCartRecoveryQuery>;
export type CartRecoveryLazyQueryHookResult = ReturnType<typeof useCartRecoveryLazyQuery>;
export type CartRecoveryQueryResult = Apollo.QueryResult<CartRecoveryQuery, CartRecoveryQueryVariables>;
export const ChangeUserPasswordDocument = gql`
    mutation ChangeUserPassword($input: ChangeUserPasswordInput!) {
  changeUserPassword(input: $input) {
    id
  }
}
    `;
export type ChangeUserPasswordMutationFn = Apollo.MutationFunction<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;

/**
 * __useChangeUserPasswordMutation__
 *
 * To run a mutation, you first call `useChangeUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserPasswordMutation, { data, loading, error }] = useChangeUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeUserPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>(ChangeUserPasswordDocument, options);
      }
export type ChangeUserPasswordMutationHookResult = ReturnType<typeof useChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationResult = Apollo.MutationResult<ChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($cartId: String!) {
  createOrder(cartId: $cartId) {
    id
    status
    cart {
      ...Cart
    }
    contactInfo {
      email
      phone
      shippingAddress {
        ...EmbeddedAddress
      }
    }
    paymentRequest {
      billingAddress {
        ...EmbeddedAddress
      }
      isBillingEqualShipping
      paymentMethod
    }
    price {
      ...Price
    }
    requestedDeliveryDate
    submissionUid
  }
}
    ${CartFragmentDoc}
${EmbeddedAddressFragmentDoc}
${PriceFragmentDoc}`;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const CreatePaymentClientTokenDocument = gql`
    mutation CreatePaymentClientToken {
  createPaymentClientToken {
    token
  }
}
    `;
export type CreatePaymentClientTokenMutationFn = Apollo.MutationFunction<CreatePaymentClientTokenMutation, CreatePaymentClientTokenMutationVariables>;

/**
 * __useCreatePaymentClientTokenMutation__
 *
 * To run a mutation, you first call `useCreatePaymentClientTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentClientTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentClientTokenMutation, { data, loading, error }] = useCreatePaymentClientTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreatePaymentClientTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePaymentClientTokenMutation, CreatePaymentClientTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePaymentClientTokenMutation, CreatePaymentClientTokenMutationVariables>(CreatePaymentClientTokenDocument, options);
      }
export type CreatePaymentClientTokenMutationHookResult = ReturnType<typeof useCreatePaymentClientTokenMutation>;
export type CreatePaymentClientTokenMutationResult = Apollo.MutationResult<CreatePaymentClientTokenMutation>;
export type CreatePaymentClientTokenMutationOptions = Apollo.BaseMutationOptions<CreatePaymentClientTokenMutation, CreatePaymentClientTokenMutationVariables>;
export const CreatePaymentMethodDocument = gql`
    mutation CreatePaymentMethod($input: CreatePaymentMethodInput!) {
  createPaymentMethod(input: $input) {
    __typename
  }
}
    `;
export type CreatePaymentMethodMutationFn = Apollo.MutationFunction<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;

/**
 * __useCreatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMethodMutation, { data, loading, error }] = useCreatePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>(CreatePaymentMethodDocument, options);
      }
export type CreatePaymentMethodMutationHookResult = ReturnType<typeof useCreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationResult = Apollo.MutationResult<CreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;
export const CreateUserAddressDocument = gql`
    mutation CreateUserAddress($input: UserAddressInput!) {
  createUserAddress(input: $input) {
    id
  }
}
    `;
export type CreateUserAddressMutationFn = Apollo.MutationFunction<CreateUserAddressMutation, CreateUserAddressMutationVariables>;

/**
 * __useCreateUserAddressMutation__
 *
 * To run a mutation, you first call `useCreateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAddressMutation, { data, loading, error }] = useCreateUserAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserAddressMutation, CreateUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserAddressMutation, CreateUserAddressMutationVariables>(CreateUserAddressDocument, options);
      }
export type CreateUserAddressMutationHookResult = ReturnType<typeof useCreateUserAddressMutation>;
export type CreateUserAddressMutationResult = Apollo.MutationResult<CreateUserAddressMutation>;
export type CreateUserAddressMutationOptions = Apollo.BaseMutationOptions<CreateUserAddressMutation, CreateUserAddressMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    insertedAt
    email
    firstName
    lastName
    userString
    addresses {
      ...Address
    }
    paymentMethods {
      creditCards {
        ...CreditCard
      }
      paypalAccounts {
        ...PaypalAccount
      }
    }
  }
}
    ${AddressFragmentDoc}
${CreditCardFragmentDoc}
${PaypalAccountFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const CurrentUserIdDocument = gql`
    query CurrentUserId {
  currentUser {
    id
  }
}
    `;

/**
 * __useCurrentUserIdQuery__
 *
 * To run a query within a React component, call `useCurrentUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserIdQuery, CurrentUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserIdQuery, CurrentUserIdQueryVariables>(CurrentUserIdDocument, options);
      }
export function useCurrentUserIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserIdQuery, CurrentUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserIdQuery, CurrentUserIdQueryVariables>(CurrentUserIdDocument, options);
        }
export type CurrentUserIdQueryHookResult = ReturnType<typeof useCurrentUserIdQuery>;
export type CurrentUserIdLazyQueryHookResult = ReturnType<typeof useCurrentUserIdLazyQuery>;
export type CurrentUserIdQueryResult = Apollo.QueryResult<CurrentUserIdQuery, CurrentUserIdQueryVariables>;
export const CurrentUserPaymentMethodsDocument = gql`
    query CurrentUserPaymentMethods {
  currentUser {
    id
    paymentMethods {
      creditCards {
        default
      }
      paypalAccounts {
        default
      }
    }
  }
}
    `;

/**
 * __useCurrentUserPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useCurrentUserPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserPaymentMethodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>(CurrentUserPaymentMethodsDocument, options);
      }
export function useCurrentUserPaymentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>(CurrentUserPaymentMethodsDocument, options);
        }
export type CurrentUserPaymentMethodsQueryHookResult = ReturnType<typeof useCurrentUserPaymentMethodsQuery>;
export type CurrentUserPaymentMethodsLazyQueryHookResult = ReturnType<typeof useCurrentUserPaymentMethodsLazyQuery>;
export type CurrentUserPaymentMethodsQueryResult = Apollo.QueryResult<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>;
export const DeleteCreditCardDocument = gql`
    mutation DeleteCreditCard($input: DeleteCreditCardInput!) {
  deleteCreditCard(input: $input)
}
    `;
export type DeleteCreditCardMutationFn = Apollo.MutationFunction<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>;

/**
 * __useDeleteCreditCardMutation__
 *
 * To run a mutation, you first call `useDeleteCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreditCardMutation, { data, loading, error }] = useDeleteCreditCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCreditCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>(DeleteCreditCardDocument, options);
      }
export type DeleteCreditCardMutationHookResult = ReturnType<typeof useDeleteCreditCardMutation>;
export type DeleteCreditCardMutationResult = Apollo.MutationResult<DeleteCreditCardMutation>;
export type DeleteCreditCardMutationOptions = Apollo.BaseMutationOptions<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>;
export const DeletePaymentMethodDocument = gql`
    mutation DeletePaymentMethod($input: DeletePaymentMethodInput!) {
  deletePaymentMethod(input: $input)
}
    `;
export type DeletePaymentMethodMutationFn = Apollo.MutationFunction<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;

/**
 * __useDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMethodMutation, { data, loading, error }] = useDeletePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument, options);
      }
export type DeletePaymentMethodMutationHookResult = ReturnType<typeof useDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationResult = Apollo.MutationResult<DeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const DeleteUserAddressDocument = gql`
    mutation DeleteUserAddress($id: UUID4!) {
  deleteUserAddress(id: $id) {
    id
  }
}
    `;
export type DeleteUserAddressMutationFn = Apollo.MutationFunction<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>;

/**
 * __useDeleteUserAddressMutation__
 *
 * To run a mutation, you first call `useDeleteUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserAddressMutation, { data, loading, error }] = useDeleteUserAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>(DeleteUserAddressDocument, options);
      }
export type DeleteUserAddressMutationHookResult = ReturnType<typeof useDeleteUserAddressMutation>;
export type DeleteUserAddressMutationResult = Apollo.MutationResult<DeleteUserAddressMutation>;
export type DeleteUserAddressMutationOptions = Apollo.BaseMutationOptions<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>;
export const FeatureFlagsDocument = gql`
    query FeatureFlags {
  featureFlags {
    name
    enabled
  }
}
    `;

/**
 * __useFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureFlagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
      }
export function useFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
        }
export type FeatureFlagsQueryHookResult = ReturnType<typeof useFeatureFlagsQuery>;
export type FeatureFlagsLazyQueryHookResult = ReturnType<typeof useFeatureFlagsLazyQuery>;
export type FeatureFlagsQueryResult = Apollo.QueryResult<FeatureFlagsQuery, FeatureFlagsQueryVariables>;
export const FindAddressDocument = gql`
    query FindAddress($input: FindAddressInput!) {
  findAddress(input: $input) {
    items {
      id
      value
      description
      type
    }
  }
}
    `;

/**
 * __useFindAddressQuery__
 *
 * To run a query within a React component, call `useFindAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAddressQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindAddressQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindAddressQuery, FindAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindAddressQuery, FindAddressQueryVariables>(FindAddressDocument, options);
      }
export function useFindAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindAddressQuery, FindAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindAddressQuery, FindAddressQueryVariables>(FindAddressDocument, options);
        }
export type FindAddressQueryHookResult = ReturnType<typeof useFindAddressQuery>;
export type FindAddressLazyQueryHookResult = ReturnType<typeof useFindAddressLazyQuery>;
export type FindAddressQueryResult = Apollo.QueryResult<FindAddressQuery, FindAddressQueryVariables>;
export const LoginUserDocument = gql`
    mutation LoginUser($email: String!, $password: String!) {
  loginUser(input: {email: $email, password: $password}) {
    id
  }
}
    `;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUserMutation, LoginUserMutationVariables>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginUserMutation, LoginUserMutationVariables>(LoginUserDocument, options);
      }
export type LoginUserMutationHookResult = ReturnType<typeof useLoginUserMutation>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUserMutation, LoginUserMutationVariables>;
export const LogoutUserDocument = gql`
    mutation logoutUser {
  logoutUser {
    id
  }
}
    `;
export type LogoutUserMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserDocument, options);
      }
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>;
export type LogoutUserMutationResult = Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>;
export const RequestPasswordResetForUserDocument = gql`
    mutation RequestPasswordResetForUser($input: RequestPasswordResetForUserInput!) {
  requestPasswordResetForUser(input: $input) {
    email
  }
}
    `;
export type RequestPasswordResetForUserMutationFn = Apollo.MutationFunction<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>;

/**
 * __useRequestPasswordResetForUserMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetForUserMutation, { data, loading, error }] = useRequestPasswordResetForUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>(RequestPasswordResetForUserDocument, options);
      }
export type RequestPasswordResetForUserMutationHookResult = ReturnType<typeof useRequestPasswordResetForUserMutation>;
export type RequestPasswordResetForUserMutationResult = Apollo.MutationResult<RequestPasswordResetForUserMutation>;
export type RequestPasswordResetForUserMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation ResetUserPassword($input: ResetUserPasswordInput!) {
  resetUserPassword(input: $input) {
    id
  }
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const RestrictedItemsByZipCodeDocument = gql`
    query RestrictedItemsByZipCode($zip: String!) {
  restrictedItemsByZipCode(zip: $zip) {
    restrictedItems {
      id
    }
  }
}
    `;

/**
 * __useRestrictedItemsByZipCodeQuery__
 *
 * To run a query within a React component, call `useRestrictedItemsByZipCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestrictedItemsByZipCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestrictedItemsByZipCodeQuery({
 *   variables: {
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useRestrictedItemsByZipCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>(RestrictedItemsByZipCodeDocument, options);
      }
export function useRestrictedItemsByZipCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>(RestrictedItemsByZipCodeDocument, options);
        }
export type RestrictedItemsByZipCodeQueryHookResult = ReturnType<typeof useRestrictedItemsByZipCodeQuery>;
export type RestrictedItemsByZipCodeLazyQueryHookResult = ReturnType<typeof useRestrictedItemsByZipCodeLazyQuery>;
export type RestrictedItemsByZipCodeQueryResult = Apollo.QueryResult<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>;
export const RetrieveAddressDocument = gql`
    query RetrieveAddress($id: String!) {
  retrieveAddress(id: $id) {
    items {
      line1
      line2
      city
      state
      zip
      country
    }
  }
}
    `;

/**
 * __useRetrieveAddressQuery__
 *
 * To run a query within a React component, call `useRetrieveAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveAddressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetrieveAddressQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RetrieveAddressQuery, RetrieveAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RetrieveAddressQuery, RetrieveAddressQueryVariables>(RetrieveAddressDocument, options);
      }
export function useRetrieveAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RetrieveAddressQuery, RetrieveAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RetrieveAddressQuery, RetrieveAddressQueryVariables>(RetrieveAddressDocument, options);
        }
export type RetrieveAddressQueryHookResult = ReturnType<typeof useRetrieveAddressQuery>;
export type RetrieveAddressLazyQueryHookResult = ReturnType<typeof useRetrieveAddressLazyQuery>;
export type RetrieveAddressQueryResult = Apollo.QueryResult<RetrieveAddressQuery, RetrieveAddressQueryVariables>;
export const SearchDiscountsDocument = gql`
    query SearchDiscounts($input: SearchDiscountsInput!) {
  searchDiscounts(input: $input) {
    discounts {
      ...Discount
    }
  }
}
    ${DiscountFragmentDoc}`;

/**
 * __useSearchDiscountsQuery__
 *
 * To run a query within a React component, call `useSearchDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDiscountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchDiscountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchDiscountsQuery, SearchDiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchDiscountsQuery, SearchDiscountsQueryVariables>(SearchDiscountsDocument, options);
      }
export function useSearchDiscountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchDiscountsQuery, SearchDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchDiscountsQuery, SearchDiscountsQueryVariables>(SearchDiscountsDocument, options);
        }
export type SearchDiscountsQueryHookResult = ReturnType<typeof useSearchDiscountsQuery>;
export type SearchDiscountsLazyQueryHookResult = ReturnType<typeof useSearchDiscountsLazyQuery>;
export type SearchDiscountsQueryResult = Apollo.QueryResult<SearchDiscountsQuery, SearchDiscountsQueryVariables>;
export const SignUpUserDocument = gql`
    mutation SignUpUser($activationCode: String!, $activationCodeRequired: Boolean, $dateOfBirth: Date, $email: String!, $emailOptIn: Boolean, $password: String!, $passwordConfirmation: String!) {
  signupUser(
    input: {activationCode: $activationCode, activationCodeRequired: $activationCodeRequired, dateOfBirth: $dateOfBirth, email: $email, emailOptIn: $emailOptIn, password: $password, passwordConfirmation: $passwordConfirmation}
  ) {
    id
    hashedEmail
  }
}
    `;
export type SignUpUserMutationFn = Apollo.MutationFunction<SignUpUserMutation, SignUpUserMutationVariables>;

/**
 * __useSignUpUserMutation__
 *
 * To run a mutation, you first call `useSignUpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpUserMutation, { data, loading, error }] = useSignUpUserMutation({
 *   variables: {
 *      activationCode: // value for 'activationCode'
 *      activationCodeRequired: // value for 'activationCodeRequired'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      email: // value for 'email'
 *      emailOptIn: // value for 'emailOptIn'
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *   },
 * });
 */
export function useSignUpUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SignUpUserMutation, SignUpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SignUpUserMutation, SignUpUserMutationVariables>(SignUpUserDocument, options);
      }
export type SignUpUserMutationHookResult = ReturnType<typeof useSignUpUserMutation>;
export type SignUpUserMutationResult = Apollo.MutationResult<SignUpUserMutation>;
export type SignUpUserMutationOptions = Apollo.BaseMutationOptions<SignUpUserMutation, SignUpUserMutationVariables>;
export const SkipOrderSubscriptionDocument = gql`
    mutation SkipOrderSubscription($id: UUID4!) {
  skipOrderSubscription(id: $id) {
    id
  }
}
    `;
export type SkipOrderSubscriptionMutationFn = Apollo.MutationFunction<SkipOrderSubscriptionMutation, SkipOrderSubscriptionMutationVariables>;

/**
 * __useSkipOrderSubscriptionMutation__
 *
 * To run a mutation, you first call `useSkipOrderSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipOrderSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipOrderSubscriptionMutation, { data, loading, error }] = useSkipOrderSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSkipOrderSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SkipOrderSubscriptionMutation, SkipOrderSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SkipOrderSubscriptionMutation, SkipOrderSubscriptionMutationVariables>(SkipOrderSubscriptionDocument, options);
      }
export type SkipOrderSubscriptionMutationHookResult = ReturnType<typeof useSkipOrderSubscriptionMutation>;
export type SkipOrderSubscriptionMutationResult = Apollo.MutationResult<SkipOrderSubscriptionMutation>;
export type SkipOrderSubscriptionMutationOptions = Apollo.BaseMutationOptions<SkipOrderSubscriptionMutation, SkipOrderSubscriptionMutationVariables>;
export const SubmitOrderDocument = gql`
    mutation SubmitOrder($orderId: String!, $input: SubmitOrderInput!) {
  submitOrder(orderId: $orderId, input: $input) {
    id
    appId
    contactInfo {
      bazaarvoice {
        encryptedEmail
        encryptionKeyId
      }
      email
      userString
      phone
      shippingAddress {
        ...EmbeddedAddress
      }
      username
    }
    submissionUid: externalOrderId
    paymentRequest {
      billingAddress {
        ...EmbeddedAddress
      }
      isBillingEqualShipping
      paymentMethod
    }
    price {
      ...Price
      items {
        id
        ...PriceItem
      }
    }
    requestedDeliveryDate
  }
}
    ${EmbeddedAddressFragmentDoc}
${PriceFragmentDoc}
${PriceItemFragmentDoc}`;
export type SubmitOrderMutationFn = Apollo.MutationFunction<SubmitOrderMutation, SubmitOrderMutationVariables>;

/**
 * __useSubmitOrderMutation__
 *
 * To run a mutation, you first call `useSubmitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOrderMutation, { data, loading, error }] = useSubmitOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitOrderMutation, SubmitOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitOrderMutation, SubmitOrderMutationVariables>(SubmitOrderDocument, options);
      }
export type SubmitOrderMutationHookResult = ReturnType<typeof useSubmitOrderMutation>;
export type SubmitOrderMutationResult = Apollo.MutationResult<SubmitOrderMutation>;
export type SubmitOrderMutationOptions = Apollo.BaseMutationOptions<SubmitOrderMutation, SubmitOrderMutationVariables>;
export const SubmittedOrderDocument = gql`
    query SubmittedOrder($orderId: UUID4!) {
  submittedOrder(orderId: $orderId) {
    externalOrderId
    submittedAt
    contactInfo {
      shippingAddress {
        ...EmbeddedAddress
      }
    }
    paymentRequest {
      isBillingEqualShipping
      paymentMethod
      billingAddress {
        ...EmbeddedAddress
      }
    }
    paymentInfo {
      cardExpirationDate
      cardholderName
      email
      externalId
      last4
      paymentMethod
      paymentType
      paypalEmail
      uniqueNumberIdentifier
    }
    price {
      shipping
      subtotal
      tax
      discount
      total
      discounts {
        ...Discount
      }
      items {
        basePrice
        discountAmount
        quantity
        item {
          id
          price
          compareAtPrice
          subscriptionMetadata {
            subscriptionPrice
          }
        }
        subscriptionIntervalInDays
      }
      taxItems {
        amount
        impositionValue
        impositionTypeId
      }
    }
    requestedDeliveryDate
    fulfillments {
      status
      trackingNumber
      trackingNumbers {
        carrierName
        status
        trackingNumber
        trackingUrl
      }
      items {
        quantity
        subscriptionIntervalInDays
        item {
          id
          title
          price
          imgUrl
          productsPerPack
          fluidOzPerPack
          subscriptionMetadata {
            isSubscribable
            subscriptionPrice
          }
        }
      }
    }
  }
}
    ${EmbeddedAddressFragmentDoc}
${DiscountFragmentDoc}`;

/**
 * __useSubmittedOrderQuery__
 *
 * To run a query within a React component, call `useSubmittedOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmittedOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmittedOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSubmittedOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubmittedOrderQuery, SubmittedOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubmittedOrderQuery, SubmittedOrderQueryVariables>(SubmittedOrderDocument, options);
      }
export function useSubmittedOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubmittedOrderQuery, SubmittedOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubmittedOrderQuery, SubmittedOrderQueryVariables>(SubmittedOrderDocument, options);
        }
export type SubmittedOrderQueryHookResult = ReturnType<typeof useSubmittedOrderQuery>;
export type SubmittedOrderLazyQueryHookResult = ReturnType<typeof useSubmittedOrderLazyQuery>;
export type SubmittedOrderQueryResult = Apollo.QueryResult<SubmittedOrderQuery, SubmittedOrderQueryVariables>;
export const SubmittedOrderForOrderConfirmationDocument = gql`
    query SubmittedOrderForOrderConfirmation($id: UUID4!) {
  submittedOrder(orderId: $id) {
    id
    externalOrderId
    submittedAt
    price {
      discounts {
        ...Discount
      }
      taxItems {
        impositionTypeId
        impositionValue
        amount
      }
      shipping
      subtotal
      total
      tax
      discount
      items {
        id
        customizations
        subscriptionIntervalInDays
        quantity
        basePrice
        discountAmount
        taxAmount
        item {
          title
          price
          compareAtPrice
          imgUrl
          subscriptionMetadata {
            subscriptionPrice
            isSubscribable
          }
        }
      }
    }
    fulfillments {
      id
      carrierName
      trackingNumber
      insertedAt
      trackingNumbers {
        status
        trackingNumber
        trackingUrl
      }
      status
      items {
        quantity
        item {
          id
          title
          imgUrl
        }
      }
    }
    paymentInfo {
      last4
      paymentType
      cardExpirationDate
    }
    contactInfo {
      shippingAddress {
        ...EmbeddedAddress
      }
      email
      phone
    }
    giftorName
    paymentRequest {
      paymentMethod
      isBillingEqualShipping
      billingAddress {
        ...EmbeddedAddress
      }
    }
  }
}
    ${DiscountFragmentDoc}
${EmbeddedAddressFragmentDoc}`;

/**
 * __useSubmittedOrderForOrderConfirmationQuery__
 *
 * To run a query within a React component, call `useSubmittedOrderForOrderConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmittedOrderForOrderConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmittedOrderForOrderConfirmationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmittedOrderForOrderConfirmationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubmittedOrderForOrderConfirmationQuery, SubmittedOrderForOrderConfirmationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubmittedOrderForOrderConfirmationQuery, SubmittedOrderForOrderConfirmationQueryVariables>(SubmittedOrderForOrderConfirmationDocument, options);
      }
export function useSubmittedOrderForOrderConfirmationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubmittedOrderForOrderConfirmationQuery, SubmittedOrderForOrderConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubmittedOrderForOrderConfirmationQuery, SubmittedOrderForOrderConfirmationQueryVariables>(SubmittedOrderForOrderConfirmationDocument, options);
        }
export type SubmittedOrderForOrderConfirmationQueryHookResult = ReturnType<typeof useSubmittedOrderForOrderConfirmationQuery>;
export type SubmittedOrderForOrderConfirmationLazyQueryHookResult = ReturnType<typeof useSubmittedOrderForOrderConfirmationLazyQuery>;
export type SubmittedOrderForOrderConfirmationQueryResult = Apollo.QueryResult<SubmittedOrderForOrderConfirmationQuery, SubmittedOrderForOrderConfirmationQueryVariables>;
export const SubmittedOrdersDocument = gql`
    query SubmittedOrders($pagination: PaginationInput = {limit: 1000, page: 1}) {
  submittedOrders(pagination: $pagination) {
    pagination {
      totalPages
    }
    submittedOrders {
      id
      orderSubscriptionRelationship
      externalOrderId
      submittedAt
      requestedDeliveryDate
      price {
        total
      }
      contactInfo {
        shippingAddress {
          nickname
          line1
          line2
          firstName
          lastName
          city
          state
          zip
        }
      }
      fulfillments {
        id
      }
    }
  }
}
    `;

/**
 * __useSubmittedOrdersQuery__
 *
 * To run a query within a React component, call `useSubmittedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmittedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmittedOrdersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSubmittedOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>(SubmittedOrdersDocument, options);
      }
export function useSubmittedOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>(SubmittedOrdersDocument, options);
        }
export type SubmittedOrdersQueryHookResult = ReturnType<typeof useSubmittedOrdersQuery>;
export type SubmittedOrdersLazyQueryHookResult = ReturnType<typeof useSubmittedOrdersLazyQuery>;
export type SubmittedOrdersQueryResult = Apollo.QueryResult<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>;
export const SubscriptionDocument = gql`
    query Subscription($id: UUID4!) {
  orderSubscription(id: $id) {
    id
    canceledAt
    title
    insertedAt
    nextDeliveryDate
    nextOrderCreationDates
    status
    statusReason
    address {
      city
      firstName
      id
      lastName
      line1
      line2
      state
      zip
    }
    user {
      paymentMethods {
        creditCards {
          last4
          expirationMonth
          expirationYear
          cardholderName
          cardType
        }
        paypalAccounts {
          email
        }
      }
    }
    paymentInfo {
      uniqueNumberIdentifier
      paymentMethod
      email
      last4
    }
    intervalInDays
    orderSubscriptionItems {
      priceItem {
        subscriptionIntervalInDays
        price {
          total
          discount
          shipping
          subtotal
          tax
          taxItems {
            amount
            impositionTypeId
            impositionValue
          }
        }
        basePrice
        item {
          id
          imgUrl
          title
          fluidOzPerPack
          productsPerPack
          subscriptionMetadata {
            subscriptionPrice
            isSubscribable
          }
        }
        quantity
      }
    }
    originatingOrder {
      price {
        shipping
      }
    }
  }
}
    `;

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
      }
export function useSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
        }
export type SubscriptionQueryHookResult = ReturnType<typeof useSubscriptionQuery>;
export type SubscriptionLazyQueryHookResult = ReturnType<typeof useSubscriptionLazyQuery>;
export type SubscriptionQueryResult = Apollo.QueryResult<SubscriptionQuery, SubscriptionQueryVariables>;
export const SubscriptionAddressesDocument = gql`
    query SubscriptionAddresses {
  orderSubscriptions {
    orderSubscriptions {
      address {
        id
      }
    }
  }
}
    `;

/**
 * __useSubscriptionAddressesQuery__
 *
 * To run a query within a React component, call `useSubscriptionAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionAddressesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>(SubscriptionAddressesDocument, options);
      }
export function useSubscriptionAddressesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>(SubscriptionAddressesDocument, options);
        }
export type SubscriptionAddressesQueryHookResult = ReturnType<typeof useSubscriptionAddressesQuery>;
export type SubscriptionAddressesLazyQueryHookResult = ReturnType<typeof useSubscriptionAddressesLazyQuery>;
export type SubscriptionAddressesQueryResult = Apollo.QueryResult<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>;
export const SubscriptionForAddressUpdateDocument = gql`
    query SubscriptionForAddressUpdate($id: UUID4!) {
  orderSubscription(id: $id) {
    id
    title
    address {
      id
    }
    orderSubscriptionItems {
      priceItem {
        currentItem {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useSubscriptionForAddressUpdateQuery__
 *
 * To run a query within a React component, call `useSubscriptionForAddressUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionForAddressUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionForAddressUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionForAddressUpdateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>(SubscriptionForAddressUpdateDocument, options);
      }
export function useSubscriptionForAddressUpdateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>(SubscriptionForAddressUpdateDocument, options);
        }
export type SubscriptionForAddressUpdateQueryHookResult = ReturnType<typeof useSubscriptionForAddressUpdateQuery>;
export type SubscriptionForAddressUpdateLazyQueryHookResult = ReturnType<typeof useSubscriptionForAddressUpdateLazyQuery>;
export type SubscriptionForAddressUpdateQueryResult = Apollo.QueryResult<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>;
export const SubscriptionsDocument = gql`
    query Subscriptions {
  orderSubscriptions {
    orderSubscriptions {
      id
      title
      intervalInDays
      insertedAt
      nextDeliveryDate
      status
      statusReason
      orderSubscriptionItems {
        priceItem {
          currentItem {
            imgUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
      }
export function useSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
export type SubscriptionsQueryHookResult = ReturnType<typeof useSubscriptionsQuery>;
export type SubscriptionsLazyQueryHookResult = ReturnType<typeof useSubscriptionsLazyQuery>;
export type SubscriptionsQueryResult = Apollo.QueryResult<SubscriptionsQuery, SubscriptionsQueryVariables>;
export const TenantDocument = gql`
    query Tenant {
  tenant {
    analyticsConfig {
      gtm {
        containerId
      }
      projectId
      writeKey
    }
    id
    brandConfig {
      customCss
      audience
      copyright
      optInText
      contactUrl
      customizations {
        contacts {
          city
          countryCode
          line1
          line2
          phoneNumber
          state
          type
          zip
        }
        fonts {
          name
          style
          urls {
            format
            local
            url
          }
          weight
          meta {
            key
            value
          }
        }
        images {
          name
          src
          alt
        }
        links {
          location
          position
          title
          url
          newTab
        }
      }
      email
      logoUrl
      title
      trackingFonts {
        isTrackingRequired
        resource
      }
      yearsAgeGate
    }
    capabilities {
      signUp {
        enabled
      }
    }
    giftConfig {
      giftingEnabled
    }
    contactConfig {
      shippingAddressConfig {
        requireValidation
        countriesAllowed {
          id
          name
        }
        note
        statesConfig {
          countryId
          statesAllowed {
            id
            name
          }
        }
      }
    }
    domain
    fallbackUrl
    paymentConfig {
      billingAddressConfig {
        requireValidation
        countriesAllowed {
          id
          name
        }
        note
        statesConfig {
          countryId
          statesAllowed {
            id
            name
          }
        }
      }
      paymentTypes {
        brandImgUrl
        id
        name
      }
    }
    shippingConfig {
      maxDeliveryWindowInDays
    }
    shoppingBagConfig {
      maxAmountForSelect
      minimumPurchaseAmount
      minimumPurchaseQty
      availableSubscriptionIntervalsInDays
      orderSubscriptionsEnabled
      subscriptionIntervalsInDays
    }
    userExperience {
      hasRequestedDeliveryDate
    }
  }
}
    `;

/**
 * __useTenantQuery__
 *
 * To run a query within a React component, call `useTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TenantQuery, TenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
      }
export function useTenantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TenantQuery, TenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
        }
export type TenantQueryHookResult = ReturnType<typeof useTenantQuery>;
export type TenantLazyQueryHookResult = ReturnType<typeof useTenantLazyQuery>;
export type TenantQueryResult = Apollo.QueryResult<TenantQuery, TenantQueryVariables>;
export const UpdateCartItemDocument = gql`
    mutation UpdateCartItem($id: UUID4, $itemId: UUID4!, $quantity: Int!, $subscriptionIntervalInDays: Int, $customizations: Json) {
  updateCartItem(
    input: {id: $id, itemId: $itemId, quantity: $quantity, subscriptionIntervalInDays: $subscriptionIntervalInDays, customizations: $customizations}
  ) {
    ...Cart
  }
}
    ${CartFragmentDoc}`;
export type UpdateCartItemMutationFn = Apollo.MutationFunction<UpdateCartItemMutation, UpdateCartItemMutationVariables>;

/**
 * __useUpdateCartItemMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartItemMutation, { data, loading, error }] = useUpdateCartItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      itemId: // value for 'itemId'
 *      quantity: // value for 'quantity'
 *      subscriptionIntervalInDays: // value for 'subscriptionIntervalInDays'
 *      customizations: // value for 'customizations'
 *   },
 * });
 */
export function useUpdateCartItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCartItemMutation, UpdateCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCartItemMutation, UpdateCartItemMutationVariables>(UpdateCartItemDocument, options);
      }
export type UpdateCartItemMutationHookResult = ReturnType<typeof useUpdateCartItemMutation>;
export type UpdateCartItemMutationResult = Apollo.MutationResult<UpdateCartItemMutation>;
export type UpdateCartItemMutationOptions = Apollo.BaseMutationOptions<UpdateCartItemMutation, UpdateCartItemMutationVariables>;
export const UpdateCreditCardDefaultDocument = gql`
    mutation UpdateCreditCardDefault($input: UpdateCreditCardDefaultInput!) {
  updateCreditCardDefault(input: $input) {
    default
  }
}
    `;
export type UpdateCreditCardDefaultMutationFn = Apollo.MutationFunction<UpdateCreditCardDefaultMutation, UpdateCreditCardDefaultMutationVariables>;

/**
 * __useUpdateCreditCardDefaultMutation__
 *
 * To run a mutation, you first call `useUpdateCreditCardDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditCardDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditCardDefaultMutation, { data, loading, error }] = useUpdateCreditCardDefaultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreditCardDefaultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCreditCardDefaultMutation, UpdateCreditCardDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCreditCardDefaultMutation, UpdateCreditCardDefaultMutationVariables>(UpdateCreditCardDefaultDocument, options);
      }
export type UpdateCreditCardDefaultMutationHookResult = ReturnType<typeof useUpdateCreditCardDefaultMutation>;
export type UpdateCreditCardDefaultMutationResult = Apollo.MutationResult<UpdateCreditCardDefaultMutation>;
export type UpdateCreditCardDefaultMutationOptions = Apollo.BaseMutationOptions<UpdateCreditCardDefaultMutation, UpdateCreditCardDefaultMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($orderId: UUID4!, $input: UpdateOrderInput!) {
  updateOrder(orderId: $orderId, input: $input) {
    id
    status
    cart {
      ...Cart
    }
    contactInfo {
      email
      phone
      shippingAddress {
        ...EmbeddedAddress
      }
    }
    paymentRequest {
      billingAddress {
        ...EmbeddedAddress
      }
      isBillingEqualShipping
      paymentMethod
    }
    requestedDeliveryDate
    submissionUid
  }
}
    ${CartFragmentDoc}
${EmbeddedAddressFragmentDoc}`;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const UpdateOrderSubscriptionAddressDocument = gql`
    mutation UpdateOrderSubscriptionAddress($input: UpdateOrderSubscriptionAddressInput!) {
  updateOrderSubscriptionAddress(input: $input) {
    id
  }
}
    `;
export type UpdateOrderSubscriptionAddressMutationFn = Apollo.MutationFunction<UpdateOrderSubscriptionAddressMutation, UpdateOrderSubscriptionAddressMutationVariables>;

/**
 * __useUpdateOrderSubscriptionAddressMutation__
 *
 * To run a mutation, you first call `useUpdateOrderSubscriptionAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderSubscriptionAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderSubscriptionAddressMutation, { data, loading, error }] = useUpdateOrderSubscriptionAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderSubscriptionAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderSubscriptionAddressMutation, UpdateOrderSubscriptionAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrderSubscriptionAddressMutation, UpdateOrderSubscriptionAddressMutationVariables>(UpdateOrderSubscriptionAddressDocument, options);
      }
export type UpdateOrderSubscriptionAddressMutationHookResult = ReturnType<typeof useUpdateOrderSubscriptionAddressMutation>;
export type UpdateOrderSubscriptionAddressMutationResult = Apollo.MutationResult<UpdateOrderSubscriptionAddressMutation>;
export type UpdateOrderSubscriptionAddressMutationOptions = Apollo.BaseMutationOptions<UpdateOrderSubscriptionAddressMutation, UpdateOrderSubscriptionAddressMutationVariables>;
export const UpdateOrderSubscriptionPaymentDocument = gql`
    mutation UpdateOrderSubscriptionPayment($input: UpdateOrderSubscriptionPaymentInput!) {
  updateOrderSubscriptionPayment(input: $input) {
    id
  }
}
    `;
export type UpdateOrderSubscriptionPaymentMutationFn = Apollo.MutationFunction<UpdateOrderSubscriptionPaymentMutation, UpdateOrderSubscriptionPaymentMutationVariables>;

/**
 * __useUpdateOrderSubscriptionPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateOrderSubscriptionPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderSubscriptionPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderSubscriptionPaymentMutation, { data, loading, error }] = useUpdateOrderSubscriptionPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderSubscriptionPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderSubscriptionPaymentMutation, UpdateOrderSubscriptionPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrderSubscriptionPaymentMutation, UpdateOrderSubscriptionPaymentMutationVariables>(UpdateOrderSubscriptionPaymentDocument, options);
      }
export type UpdateOrderSubscriptionPaymentMutationHookResult = ReturnType<typeof useUpdateOrderSubscriptionPaymentMutation>;
export type UpdateOrderSubscriptionPaymentMutationResult = Apollo.MutationResult<UpdateOrderSubscriptionPaymentMutation>;
export type UpdateOrderSubscriptionPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateOrderSubscriptionPaymentMutation, UpdateOrderSubscriptionPaymentMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation UpdateSubscription($input: UpdateOrderSubscriptionInput!) {
  updateOrderSubscription(input: $input) {
    id
    title
  }
}
    `;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const UpdateSubscriptionStatusDocument = gql`
    mutation UpdateSubscriptionStatus($input: UpdateOrderSubscriptionStatusInput!) {
  updateOrderSubscriptionStatus(input: $input) {
    id
  }
}
    `;
export type UpdateSubscriptionStatusMutationFn = Apollo.MutationFunction<UpdateSubscriptionStatusMutation, UpdateSubscriptionStatusMutationVariables>;

/**
 * __useUpdateSubscriptionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionStatusMutation, { data, loading, error }] = useUpdateSubscriptionStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionStatusMutation, UpdateSubscriptionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionStatusMutation, UpdateSubscriptionStatusMutationVariables>(UpdateSubscriptionStatusDocument, options);
      }
export type UpdateSubscriptionStatusMutationHookResult = ReturnType<typeof useUpdateSubscriptionStatusMutation>;
export type UpdateSubscriptionStatusMutationResult = Apollo.MutationResult<UpdateSubscriptionStatusMutation>;
export type UpdateSubscriptionStatusMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionStatusMutation, UpdateSubscriptionStatusMutationVariables>;
export const UpdateUserAddressDocument = gql`
    mutation UpdateUserAddress($id: UUID4!, $input: UserAddressInput!) {
  updateUserAddress(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateUserAddressMutationFn = Apollo.MutationFunction<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;

/**
 * __useUpdateUserAddressMutation__
 *
 * To run a mutation, you first call `useUpdateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAddressMutation, { data, loading, error }] = useUpdateUserAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>(UpdateUserAddressDocument, options);
      }
export type UpdateUserAddressMutationHookResult = ReturnType<typeof useUpdateUserAddressMutation>;
export type UpdateUserAddressMutationResult = Apollo.MutationResult<UpdateUserAddressMutation>;
export type UpdateUserAddressMutationOptions = Apollo.BaseMutationOptions<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;
export const UpdateUserAddressDefaultDocument = gql`
    mutation UpdateUserAddressDefault($id: UUID4!, $input: UserAddressIsDefaultInput!) {
  updateUserAddressIsDefault(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateUserAddressDefaultMutationFn = Apollo.MutationFunction<UpdateUserAddressDefaultMutation, UpdateUserAddressDefaultMutationVariables>;

/**
 * __useUpdateUserAddressDefaultMutation__
 *
 * To run a mutation, you first call `useUpdateUserAddressDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAddressDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAddressDefaultMutation, { data, loading, error }] = useUpdateUserAddressDefaultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAddressDefaultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserAddressDefaultMutation, UpdateUserAddressDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserAddressDefaultMutation, UpdateUserAddressDefaultMutationVariables>(UpdateUserAddressDefaultDocument, options);
      }
export type UpdateUserAddressDefaultMutationHookResult = ReturnType<typeof useUpdateUserAddressDefaultMutation>;
export type UpdateUserAddressDefaultMutationResult = Apollo.MutationResult<UpdateUserAddressDefaultMutation>;
export type UpdateUserAddressDefaultMutationOptions = Apollo.BaseMutationOptions<UpdateUserAddressDefaultMutation, UpdateUserAddressDefaultMutationVariables>;
export const UserAddressVerificationDocument = gql`
    mutation UserAddressVerification($input: VerifyAddressInput!) {
  userAddressVerification(input: $input) {
    ...VerifiedAddress
  }
}
    ${VerifiedAddressFragmentDoc}`;
export type UserAddressVerificationMutationFn = Apollo.MutationFunction<UserAddressVerificationMutation, UserAddressVerificationMutationVariables>;

/**
 * __useUserAddressVerificationMutation__
 *
 * To run a mutation, you first call `useUserAddressVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAddressVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAddressVerificationMutation, { data, loading, error }] = useUserAddressVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserAddressVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserAddressVerificationMutation, UserAddressVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserAddressVerificationMutation, UserAddressVerificationMutationVariables>(UserAddressVerificationDocument, options);
      }
export type UserAddressVerificationMutationHookResult = ReturnType<typeof useUserAddressVerificationMutation>;
export type UserAddressVerificationMutationResult = Apollo.MutationResult<UserAddressVerificationMutation>;
export type UserAddressVerificationMutationOptions = Apollo.BaseMutationOptions<UserAddressVerificationMutation, UserAddressVerificationMutationVariables>;
export const VerifyAddressForOrderDocument = gql`
    mutation VerifyAddressForOrder($input: VerifyAddressInput!, $orderId: String!) {
  verifyAddressForOrder(input: $input, orderId: $orderId) {
    ...VerifiedAddress
  }
}
    ${VerifiedAddressFragmentDoc}`;
export type VerifyAddressForOrderMutationFn = Apollo.MutationFunction<VerifyAddressForOrderMutation, VerifyAddressForOrderMutationVariables>;

/**
 * __useVerifyAddressForOrderMutation__
 *
 * To run a mutation, you first call `useVerifyAddressForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAddressForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAddressForOrderMutation, { data, loading, error }] = useVerifyAddressForOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useVerifyAddressForOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyAddressForOrderMutation, VerifyAddressForOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyAddressForOrderMutation, VerifyAddressForOrderMutationVariables>(VerifyAddressForOrderDocument, options);
      }
export type VerifyAddressForOrderMutationHookResult = ReturnType<typeof useVerifyAddressForOrderMutation>;
export type VerifyAddressForOrderMutationResult = Apollo.MutationResult<VerifyAddressForOrderMutation>;
export type VerifyAddressForOrderMutationOptions = Apollo.BaseMutationOptions<VerifyAddressForOrderMutation, VerifyAddressForOrderMutationVariables>;